{
  "1": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "korea",
        "label": "韓国"
      },
      {
        "country_id": "china",
        "label": "中国"
      },
      {
        "country_id": "taiwan",
        "label": "台湾"
      },
      {
        "country_id": "hong-kong",
        "label": "香港"
      },
      {
        "country_id": "macau",
        "label": "マカオ"
      },
      {
        "country_id": "mongolia",
        "label": "モンゴル"
      },
      {
        "country_id": "north-korea",
        "label": "北朝鮮"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/1/mongolia/argalant/",
          "label": "アルガラント",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/altai/",
          "label": "アルタイ",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/ulaanbaatar/",
          "label": "ウランバートル",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/korea/ulleungdo/",
          "label": "ウルルン島（鬱陵島）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/mongolia/ulaangom/",
          "label": "オラーンゴム",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/china/kashgar/",
          "label": "カシュガル（喀什）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/mongolia/kharkhorin/",
          "label": "カラコルム",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/korea/seoul/",
          "label": "ソウル（Seoul）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jeju/",
          "label": "チェジュ島（済州島）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/mongolia/choibalsan/",
          "label": "チョイバルサン",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/macau/macau/",
          "label": "マカオ",
          "country_ja": "マカオ"
        },
        {
          "point_id": "/1/mongolia/murun/",
          "label": "ムルン",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/china/shanghai/",
          "label": "上海（シャンハイ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/hong-kong/kowloon/",
          "label": "九龍（クーロン）",
          "country_ja": "香港"
        },
        {
          "point_id": "/1/korea/incheon/",
          "label": "仁川（インチョン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gwangju/",
          "label": "光州（クァンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jeonju/",
          "label": "全州（チョンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gongju/",
          "label": "公州（コンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/beijing/",
          "label": "北京（ペキン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanjing/",
          "label": "南京（ナンキン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanning/",
          "label": "南寧（ナンニン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanchang/",
          "label": "南昌（ナンチャン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xiamen/",
          "label": "厦門（アモイ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/taiwan/taichung/",
          "label": "台中（タイチュン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/taipei/",
          "label": "台北（タイペイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/tainan/",
          "label": "台南（タイナン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/taitung/",
          "label": "台東（タイドン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/china/turpan/",
          "label": "吐魯番（トルファン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/hohhot/",
          "label": "呼和浩特（フーホハオト）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/north-korea/hamhung/",
          "label": "咸興（ハムフン）",
          "country_ja": "北朝鮮"
        },
        {
          "point_id": "/1/china/harbin/",
          "label": "哈爾浜（ハルビン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/taiwan/keelung/",
          "label": "基隆（キールン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/korea/daejeon/",
          "label": "大田（テジョン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/dalian/",
          "label": "大連（ターリエン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/daegu/",
          "label": "大邱（テグ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/tianjin/",
          "label": "天津（ティエンチン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/north-korea/pyongyang/",
          "label": "平壌（ピョンヤン）",
          "country_ja": "北朝鮮"
        },
        {
          "point_id": "/1/china/guangzhou/",
          "label": "広州（コワンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/taiwan/hengchuen/",
          "label": "恒春（ホンチュン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/korea/gyeongju/",
          "label": "慶州（キョンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/chengdu/",
          "label": "成都（チョントゥー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/buyeo/",
          "label": "扶余（フヨ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/lhasa/",
          "label": "拉薩（ラサ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/dunhuang/",
          "label": "敦煌（トゥンホワン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/qiqihar/",
          "label": "斉斉哈爾（チチハル）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/taiwan/new-taipei/",
          "label": "新北（シンペイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/china/kunming/",
          "label": "昆明（クンミン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/mokpo/",
          "label": "木浦（モクポ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/hangzhou/",
          "label": "杭州（ハンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/golmud/",
          "label": "格爾木（ゴルムド）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/guilin/",
          "label": "桂林（コイリン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/taiwan/taoyuan/",
          "label": "桃園（タオユエン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/china/leshan/",
          "label": "楽山（ローシャン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/wuhan/",
          "label": "武漢（ウーハン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/suwon/",
          "label": "水原（スウォン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gangneung/",
          "label": "江陵（カンヌン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/pohang/",
          "label": "浦項（ポハン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/taiwan/tamsui/",
          "label": "淡水（ダンシュイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/north-korea/chongjin/",
          "label": "清津（チョンジン）",
          "country_ja": "北朝鮮"
        },
        {
          "point_id": "/1/china/jinan/",
          "label": "済南（チーナン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/urumqi/",
          "label": "烏魯木斉（ウルムチ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/wuxi/",
          "label": "無錫（ウーシー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/fuzhou/",
          "label": "福州（フーチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/ulsan/",
          "label": "蔚山（ウルサン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/suzhou/",
          "label": "蘇州（スーチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/lanzhou/",
          "label": "蘭州（ランチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xian/",
          "label": "西安（シーアン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xining/",
          "label": "西寧（シーニン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/zhengzhou/",
          "label": "鄭州（チョンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/chongqing/",
          "label": "重慶（チョンチン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/korea/busan/",
          "label": "釜山（プサン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jinhae/",
          "label": "鎮海（チネ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/china/changchun/",
          "label": "長春（チャンチュン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/changsha/",
          "label": "長沙（チャンシャー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/qingdao/",
          "label": "青島（チンタオ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/hong-kong/hong-kong/",
          "label": "香港（ホンコン）",
          "country_ja": "香港"
        },
        {
          "point_id": "/1/taiwan/kaohsiung/",
          "label": "高雄（カオシュン）",
          "country_ja": "台湾"
        }
      ],
      "korea": [
        {
          "point_id": "/1/korea/ulleungdo/",
          "label": "ウルルン島（鬱陵島）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/seoul/",
          "label": "ソウル（Seoul）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jeju/",
          "label": "チェジュ島（済州島）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/incheon/",
          "label": "仁川（インチョン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gwangju/",
          "label": "光州（クァンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jeonju/",
          "label": "全州（チョンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gongju/",
          "label": "公州（コンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/daejeon/",
          "label": "大田（テジョン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/daegu/",
          "label": "大邱（テグ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gyeongju/",
          "label": "慶州（キョンジュ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/buyeo/",
          "label": "扶余（フヨ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/mokpo/",
          "label": "木浦（モクポ）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/suwon/",
          "label": "水原（スウォン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/gangneung/",
          "label": "江陵（カンヌン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/pohang/",
          "label": "浦項（ポハン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/ulsan/",
          "label": "蔚山（ウルサン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/busan/",
          "label": "釜山（プサン）",
          "country_ja": "韓国"
        },
        {
          "point_id": "/1/korea/jinhae/",
          "label": "鎮海（チネ）",
          "country_ja": "韓国"
        }
      ],
      "north-korea": [
        {
          "point_id": "/1/north-korea/hamhung/",
          "label": "咸興（ハムフン）",
          "country_ja": "北朝鮮"
        },
        {
          "point_id": "/1/north-korea/pyongyang/",
          "label": "平壌（ピョンヤン）",
          "country_ja": "北朝鮮"
        },
        {
          "point_id": "/1/north-korea/chongjin/",
          "label": "清津（チョンジン）",
          "country_ja": "北朝鮮"
        }
      ],
      "taiwan": [
        {
          "point_id": "/1/taiwan/taichung/",
          "label": "台中（タイチュン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/taipei/",
          "label": "台北（タイペイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/tainan/",
          "label": "台南（タイナン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/taitung/",
          "label": "台東（タイドン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/keelung/",
          "label": "基隆（キールン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/hengchuen/",
          "label": "恒春（ホンチュン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/new-taipei/",
          "label": "新北（シンペイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/taoyuan/",
          "label": "桃園（タオユエン）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/tamsui/",
          "label": "淡水（ダンシュイ）",
          "country_ja": "台湾"
        },
        {
          "point_id": "/1/taiwan/kaohsiung/",
          "label": "高雄（カオシュン）",
          "country_ja": "台湾"
        }
      ],
      "china": [
        {
          "point_id": "/1/china/kashgar/",
          "label": "カシュガル（喀什）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/shanghai/",
          "label": "上海（シャンハイ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/beijing/",
          "label": "北京（ペキン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanjing/",
          "label": "南京（ナンキン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanning/",
          "label": "南寧（ナンニン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/nanchang/",
          "label": "南昌（ナンチャン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xiamen/",
          "label": "厦門（アモイ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/turpan/",
          "label": "吐魯番（トルファン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/hohhot/",
          "label": "呼和浩特（フーホハオト）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/harbin/",
          "label": "哈爾浜（ハルビン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/dalian/",
          "label": "大連（ターリエン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/tianjin/",
          "label": "天津（ティエンチン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/guangzhou/",
          "label": "広州（コワンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/chengdu/",
          "label": "成都（チョントゥー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/lhasa/",
          "label": "拉薩（ラサ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/dunhuang/",
          "label": "敦煌（トゥンホワン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/qiqihar/",
          "label": "斉斉哈爾（チチハル）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/kunming/",
          "label": "昆明（クンミン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/hangzhou/",
          "label": "杭州（ハンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/golmud/",
          "label": "格爾木（ゴルムド）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/guilin/",
          "label": "桂林（コイリン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/leshan/",
          "label": "楽山（ローシャン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/wuhan/",
          "label": "武漢（ウーハン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/jinan/",
          "label": "済南（チーナン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/urumqi/",
          "label": "烏魯木斉（ウルムチ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/wuxi/",
          "label": "無錫（ウーシー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/fuzhou/",
          "label": "福州（フーチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/suzhou/",
          "label": "蘇州（スーチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/lanzhou/",
          "label": "蘭州（ランチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xian/",
          "label": "西安（シーアン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/xining/",
          "label": "西寧（シーニン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/zhengzhou/",
          "label": "鄭州（チョンチョウ）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/chongqing/",
          "label": "重慶（チョンチン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/changchun/",
          "label": "長春（チャンチュン）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/changsha/",
          "label": "長沙（チャンシャー）",
          "country_ja": "中国"
        },
        {
          "point_id": "/1/china/qingdao/",
          "label": "青島（チンタオ）",
          "country_ja": "中国"
        }
      ],
      "hong-kong": [
        {
          "point_id": "/1/hong-kong/kowloon/",
          "label": "九龍（クーロン）",
          "country_ja": "香港"
        },
        {
          "point_id": "/1/hong-kong/hong-kong/",
          "label": "香港（ホンコン）",
          "country_ja": "香港"
        }
      ],
      "macau": [
        {
          "point_id": "/1/macau/macau/",
          "label": "マカオ",
          "country_ja": "マカオ"
        }
      ],
      "mongolia": [
        {
          "point_id": "/1/mongolia/argalant/",
          "label": "アルガラント",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/altai/",
          "label": "アルタイ",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/ulaanbaatar/",
          "label": "ウランバートル",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/ulaangom/",
          "label": "オラーンゴム",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/kharkhorin/",
          "label": "カラコルム",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/choibalsan/",
          "label": "チョイバルサン",
          "country_ja": "モンゴル"
        },
        {
          "point_id": "/1/mongolia/murun/",
          "label": "ムルン",
          "country_ja": "モンゴル"
        }
      ]
    }
  },
  "3": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "india",
        "label": "インド"
      },
      {
        "country_id": "sri-lanka",
        "label": "スリランカ"
      },
      {
        "country_id": "nepal",
        "label": "ネパール"
      },
      {
        "country_id": "bangladesh",
        "label": "バングラデシュ"
      },
      {
        "country_id": "pakistan",
        "label": "パキスタン"
      },
      {
        "country_id": "bhutan",
        "label": "ブータン王国"
      },
      {
        "country_id": "maldives",
        "label": "モルディブ"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/3/india/aurangabad/",
          "label": "アウランガーバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/maldives/kot-addu/",
          "label": "アッドゥ環礁",
          "country_ja": "モルディブ"
        },
        {
          "point_id": "/3/sri-lanka/anuradhapura/",
          "label": "アヌラダプラ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/allahabad/",
          "label": "アラハバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/agra/",
          "label": "アーグラ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/ahmedabad/",
          "label": "アーメダバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/pakistan/islamabad/",
          "label": "イスラマバード",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/india/udaipur/",
          "label": "ウダイプール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/nepal/kathmandu/",
          "label": "カトマンズ",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/pakistan/karachi/",
          "label": "カラチ",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/sri-lanka/kandy/",
          "label": "キャンディ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/gwalior/",
          "label": "グワリオル",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/kolkata/",
          "label": "コルカタ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/sri-lanka/colombo/",
          "label": "コロンボ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/kochi/",
          "label": "コーチン",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/sri-lanka/galle/",
          "label": "ゴール",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/jaipur/",
          "label": "ジャイプール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/sri-lanka/sri-jayewardenepura-kotte/",
          "label": "スリ・ジャヤワルダナプラ・コッテ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/bangladesh/dhaka/",
          "label": "ダッカ",
          "country_ja": "バングラデシュ"
        },
        {
          "point_id": "/3/sri-lanka/dambulla/",
          "label": "ダンブッラ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/chennai/",
          "label": "チェンナイ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/bangladesh/chittagong/",
          "label": "チッタゴン",
          "country_ja": "バングラデシュ"
        },
        {
          "point_id": "/3/india/tiruchirappalli/",
          "label": "ティルチラーパリ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/bhutan/thimphu/",
          "label": "ティンプー",
          "country_ja": "ブータン王国"
        },
        {
          "point_id": "/3/india/thiruvananthapuram/",
          "label": "トリバンドラム",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/nepal/nagarkot/",
          "label": "ナガルコット",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/india/new-delhi/",
          "label": "ニューデリー",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/sri-lanka/nuwara-eliya/",
          "label": "ヌワラエリア",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/negombo/",
          "label": "ネゴンボ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/india/hyderabad/",
          "label": "ハイデラバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/nepal/bhaktapur/",
          "label": "バクタプル",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/india/varanasi/",
          "label": "バラナシ（ベナレス）",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/bangalore/",
          "label": "バンガロール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/nepal/patan/",
          "label": "パタン",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/india/bodhgaya/",
          "label": "ブッダガヤ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/sri-lanka/puttalam/",
          "label": "プッタラム",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/pakistan/peshawar/",
          "label": "ペシャワル",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/nepal/pokhara/",
          "label": "ポカラ",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/sri-lanka/polonnaruwa/",
          "label": "ポロンナルワ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/maldives/male/",
          "label": "マレ",
          "country_ja": "モルディブ"
        },
        {
          "point_id": "/3/india/mumbai/",
          "label": "ムンバイ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/pakistan/lahore/",
          "label": "ラホール",
          "country_ja": "パキスタン"
        }
      ],
      "india": [
        {
          "point_id": "/3/india/aurangabad/",
          "label": "アウランガーバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/allahabad/",
          "label": "アラハバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/agra/",
          "label": "アーグラ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/ahmedabad/",
          "label": "アーメダバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/udaipur/",
          "label": "ウダイプール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/gwalior/",
          "label": "グワリオル",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/kolkata/",
          "label": "コルカタ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/kochi/",
          "label": "コーチン",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/jaipur/",
          "label": "ジャイプール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/chennai/",
          "label": "チェンナイ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/tiruchirappalli/",
          "label": "ティルチラーパリ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/thiruvananthapuram/",
          "label": "トリバンドラム",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/new-delhi/",
          "label": "ニューデリー",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/hyderabad/",
          "label": "ハイデラバード",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/varanasi/",
          "label": "バラナシ（ベナレス）",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/bangalore/",
          "label": "バンガロール",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/bodhgaya/",
          "label": "ブッダガヤ",
          "country_ja": "インド"
        },
        {
          "point_id": "/3/india/mumbai/",
          "label": "ムンバイ",
          "country_ja": "インド"
        }
      ],
      "sri-lanka": [
        {
          "point_id": "/3/sri-lanka/anuradhapura/",
          "label": "アヌラダプラ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/kandy/",
          "label": "キャンディ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/colombo/",
          "label": "コロンボ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/galle/",
          "label": "ゴール",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/sri-jayewardenepura-kotte/",
          "label": "スリ・ジャヤワルダナプラ・コッテ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/dambulla/",
          "label": "ダンブッラ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/nuwara-eliya/",
          "label": "ヌワラエリア",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/negombo/",
          "label": "ネゴンボ",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/puttalam/",
          "label": "プッタラム",
          "country_ja": "スリランカ"
        },
        {
          "point_id": "/3/sri-lanka/polonnaruwa/",
          "label": "ポロンナルワ",
          "country_ja": "スリランカ"
        }
      ],
      "nepal": [
        {
          "point_id": "/3/nepal/kathmandu/",
          "label": "カトマンズ",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/nepal/nagarkot/",
          "label": "ナガルコット",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/nepal/bhaktapur/",
          "label": "バクタプル",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/nepal/patan/",
          "label": "パタン",
          "country_ja": "ネパール"
        },
        {
          "point_id": "/3/nepal/pokhara/",
          "label": "ポカラ",
          "country_ja": "ネパール"
        }
      ],
      "bangladesh": [
        {
          "point_id": "/3/bangladesh/dhaka/",
          "label": "ダッカ",
          "country_ja": "バングラデシュ"
        },
        {
          "point_id": "/3/bangladesh/chittagong/",
          "label": "チッタゴン",
          "country_ja": "バングラデシュ"
        }
      ],
      "pakistan": [
        {
          "point_id": "/3/pakistan/islamabad/",
          "label": "イスラマバード",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/pakistan/karachi/",
          "label": "カラチ",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/pakistan/peshawar/",
          "label": "ペシャワル",
          "country_ja": "パキスタン"
        },
        {
          "point_id": "/3/pakistan/lahore/",
          "label": "ラホール",
          "country_ja": "パキスタン"
        }
      ],
      "maldives": [
        {
          "point_id": "/3/maldives/kot-addu/",
          "label": "アッドゥ環礁",
          "country_ja": "モルディブ"
        },
        {
          "point_id": "/3/maldives/male/",
          "label": "マレ",
          "country_ja": "モルディブ"
        }
      ],
      "bhutan": [
        {
          "point_id": "/3/bhutan/thimphu/",
          "label": "ティンプー",
          "country_ja": "ブータン王国"
        }
      ]
    }
  },
  "2": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "indonesia",
        "label": "インドネシア"
      },
      {
        "country_id": "cambodia",
        "label": "カンボジア"
      },
      {
        "country_id": "singapore",
        "label": "シンガポール"
      },
      {
        "country_id": "thailand",
        "label": "タイ"
      },
      {
        "country_id": "philippines",
        "label": "フィリピン"
      },
      {
        "country_id": "brunei",
        "label": "ブルネイ"
      },
      {
        "country_id": "vietnam",
        "label": "ベトナム"
      },
      {
        "country_id": "malaysia",
        "label": "マレーシア"
      },
      {
        "country_id": "myanmar",
        "label": "ミャンマー"
      },
      {
        "country_id": "laos",
        "label": "ラオス人民民主共和国"
      },
      {
        "country_id": "east-timor",
        "label": "東ティモール民主共和国"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/2/philippines/iloilo/",
          "label": "イロイロ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/indonesia/ubud/",
          "label": "ウブド（バリ島）",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/thailand/kanchanaburi/",
          "label": "カンチャナブリ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/malaysia/cameron-highlands/",
          "label": "キャメロンハイランド",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/kuala-lumpur/",
          "label": "クアラルンプール",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/thailand/ko-kut/",
          "label": "クッド島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/malaysia/kota-kinabalu/",
          "label": "コタキナバル",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/thailand/samui/",
          "label": "サムイ島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/cambodia/sihanoukville/",
          "label": "シアヌークビル",
          "country_ja": "カンボジア"
        },
        {
          "point_id": "/2/cambodia/siem-reap/",
          "label": "シェムリアップ",
          "country_ja": "カンボジア"
        },
        {
          "point_id": "/2/singapore/singapore/",
          "label": "シンガポール",
          "country_ja": "シンガポール"
        },
        {
          "point_id": "/2/indonesia/jakarta/",
          "label": "ジャカルタ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/yogyakarta/",
          "label": "ジョグジャカルタ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/malaysia/johor-bahru/",
          "label": "ジョホールバル",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/george-town/",
          "label": "ジョージタウン（ペナン島）",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/thailand/sukhothai/",
          "label": "スコタイ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/indonesia/surabaya/",
          "label": "スラバヤ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/philippines/cebu-city/",
          "label": "セブ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/singapore/sentosa/",
          "label": "セントーサ島",
          "country_ja": "シンガポール"
        },
        {
          "point_id": "/2/indonesia/solon/",
          "label": "ソロン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/philippines/bohol-island/",
          "label": "タグビララン（ボホール島）",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/indonesia/tarakan/",
          "label": "タラカン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/tanjung-pandan/",
          "label": "タンジュンパンダン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/vietnam/da-nang/",
          "label": "ダナン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/philippines/davao/",
          "label": "ダバオ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/thailand/chiang-mai/",
          "label": "チェンマイ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/chiang-rai/",
          "label": "チエンライ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/east-timor/dili/",
          "label": "ディリ",
          "country_ja": "東ティモール民主共和国"
        },
        {
          "point_id": "/2/indonesia/denpasar/",
          "label": "デンパサール（バリ島）",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/vietnam/dong-hoi/",
          "label": "ドンホイ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/thailand/nakhon-ratchasima/",
          "label": "ナコン・ラチャシーマー",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/narathiwat/",
          "label": "ナラーティワート",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/nan/",
          "label": "ナーン",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/vietnam/nha-trang/",
          "label": "ニャチャン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/ninh-binh/",
          "label": "ニンビン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/myanmar/naypyidaw/",
          "label": "ネピドー",
          "country_ja": "ミャンマー"
        },
        {
          "point_id": "/2/vietnam/ha-noi/",
          "label": "ハノイ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/haron/",
          "label": "ハロン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/bac-giang/",
          "label": "バッチャン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/indonesia/balikpapan/",
          "label": "バリクパパン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/thailand/bangkok/",
          "label": "バンコク",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/brunei/bandar-seri-begawan/",
          "label": "バンダルスリブガワン",
          "country_ja": "ブルネイ"
        },
        {
          "point_id": "/2/indonesia/bandung/",
          "label": "バンドン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/thailand/phatthaya/",
          "label": "パタヤ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/philippines/vigan/",
          "label": "ビガン",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/thailand/ko-phi-phi/",
          "label": "ピピ・ドン島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/vietnam/hue/",
          "label": "フエ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/malaysia/putrajaya/",
          "label": "プトラジャヤ",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/cambodia/phnom-penh/",
          "label": "プノンペン",
          "country_ja": "カンボジア"
        },
        {
          "point_id": "/2/thailand/phuket/",
          "label": "プーケット",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/hua-hin/",
          "label": "ホアヒン",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/vietnam/hoi-an/",
          "label": "ホイアン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/ho-chi-minh/",
          "label": "ホーチミン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/indonesia/pontianak/",
          "label": "ポンティアナク",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/makassar/",
          "label": "マカッサル",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/philippines/manila/",
          "label": "マニラ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/malaysia/malacca/",
          "label": "マラッカ",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/myanmar/mandalay/",
          "label": "マンダレー",
          "country_ja": "ミャンマー"
        },
        {
          "point_id": "/2/vietnam/my-tho/",
          "label": "ミトー",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/indonesia/medan/",
          "label": "メダン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/thailand/mae-sot/",
          "label": "メーソト",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/mae-hong-son/",
          "label": "メーホンソン",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/myanmar/yangon/",
          "label": "ヤンゴン",
          "country_ja": "ミャンマー"
        },
        {
          "point_id": "/2/philippines/laoag/",
          "label": "ラオアグ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/mactan-island/",
          "label": "ラプラプ（マクタン島）",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/malaysia/langkawi/",
          "label": "ランカウイ",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/laos/luang-prabang/",
          "label": "ルアンパバン",
          "country_ja": "ラオス人民民主共和国"
        },
        {
          "point_id": "/2/indonesia/lhokseumawe/",
          "label": "ロークスマウェ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/laos/vientiane/",
          "label": "ヴィエンチャン",
          "country_ja": "ラオス人民民主共和国"
        }
      ],
      "indonesia": [
        {
          "point_id": "/2/indonesia/ubud/",
          "label": "ウブド（バリ島）",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/jakarta/",
          "label": "ジャカルタ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/yogyakarta/",
          "label": "ジョグジャカルタ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/surabaya/",
          "label": "スラバヤ",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/solon/",
          "label": "ソロン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/tarakan/",
          "label": "タラカン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/tanjung-pandan/",
          "label": "タンジュンパンダン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/denpasar/",
          "label": "デンパサール（バリ島）",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/balikpapan/",
          "label": "バリクパパン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/bandung/",
          "label": "バンドン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/pontianak/",
          "label": "ポンティアナク",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/makassar/",
          "label": "マカッサル",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/medan/",
          "label": "メダン",
          "country_ja": "インドネシア"
        },
        {
          "point_id": "/2/indonesia/lhokseumawe/",
          "label": "ロークスマウェ",
          "country_ja": "インドネシア"
        }
      ],
      "cambodia": [
        {
          "point_id": "/2/cambodia/sihanoukville/",
          "label": "シアヌークビル",
          "country_ja": "カンボジア"
        },
        {
          "point_id": "/2/cambodia/siem-reap/",
          "label": "シェムリアップ",
          "country_ja": "カンボジア"
        },
        {
          "point_id": "/2/cambodia/phnom-penh/",
          "label": "プノンペン",
          "country_ja": "カンボジア"
        }
      ],
      "singapore": [
        {
          "point_id": "/2/singapore/singapore/",
          "label": "シンガポール",
          "country_ja": "シンガポール"
        },
        {
          "point_id": "/2/singapore/sentosa/",
          "label": "セントーサ島",
          "country_ja": "シンガポール"
        }
      ],
      "thailand": [
        {
          "point_id": "/2/thailand/kanchanaburi/",
          "label": "カンチャナブリ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/ko-kut/",
          "label": "クッド島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/samui/",
          "label": "サムイ島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/sukhothai/",
          "label": "スコタイ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/chiang-mai/",
          "label": "チェンマイ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/chiang-rai/",
          "label": "チエンライ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/nakhon-ratchasima/",
          "label": "ナコン・ラチャシーマー",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/narathiwat/",
          "label": "ナラーティワート",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/nan/",
          "label": "ナーン",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/bangkok/",
          "label": "バンコク",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/phatthaya/",
          "label": "パタヤ",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/ko-phi-phi/",
          "label": "ピピ・ドン島",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/phuket/",
          "label": "プーケット",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/hua-hin/",
          "label": "ホアヒン",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/mae-sot/",
          "label": "メーソト",
          "country_ja": "タイ"
        },
        {
          "point_id": "/2/thailand/mae-hong-son/",
          "label": "メーホンソン",
          "country_ja": "タイ"
        }
      ],
      "philippines": [
        {
          "point_id": "/2/philippines/iloilo/",
          "label": "イロイロ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/cebu-city/",
          "label": "セブ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/bohol-island/",
          "label": "タグビララン（ボホール島）",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/davao/",
          "label": "ダバオ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/vigan/",
          "label": "ビガン",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/manila/",
          "label": "マニラ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/laoag/",
          "label": "ラオアグ",
          "country_ja": "フィリピン"
        },
        {
          "point_id": "/2/philippines/mactan-island/",
          "label": "ラプラプ（マクタン島）",
          "country_ja": "フィリピン"
        }
      ],
      "brunei": [
        {
          "point_id": "/2/brunei/bandar-seri-begawan/",
          "label": "バンダルスリブガワン",
          "country_ja": "ブルネイ"
        }
      ],
      "vietnam": [
        {
          "point_id": "/2/vietnam/da-nang/",
          "label": "ダナン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/dong-hoi/",
          "label": "ドンホイ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/nha-trang/",
          "label": "ニャチャン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/ninh-binh/",
          "label": "ニンビン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/ha-noi/",
          "label": "ハノイ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/haron/",
          "label": "ハロン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/bac-giang/",
          "label": "バッチャン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/hue/",
          "label": "フエ",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/hoi-an/",
          "label": "ホイアン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/ho-chi-minh/",
          "label": "ホーチミン",
          "country_ja": "ベトナム"
        },
        {
          "point_id": "/2/vietnam/my-tho/",
          "label": "ミトー",
          "country_ja": "ベトナム"
        }
      ],
      "malaysia": [
        {
          "point_id": "/2/malaysia/cameron-highlands/",
          "label": "キャメロンハイランド",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/kuala-lumpur/",
          "label": "クアラルンプール",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/kota-kinabalu/",
          "label": "コタキナバル",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/johor-bahru/",
          "label": "ジョホールバル",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/george-town/",
          "label": "ジョージタウン（ペナン島）",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/putrajaya/",
          "label": "プトラジャヤ",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/malacca/",
          "label": "マラッカ",
          "country_ja": "マレーシア"
        },
        {
          "point_id": "/2/malaysia/langkawi/",
          "label": "ランカウイ",
          "country_ja": "マレーシア"
        }
      ],
      "myanmar": [
        {
          "point_id": "/2/myanmar/naypyidaw/",
          "label": "ネピドー",
          "country_ja": "ミャンマー"
        },
        {
          "point_id": "/2/myanmar/mandalay/",
          "label": "マンダレー",
          "country_ja": "ミャンマー"
        },
        {
          "point_id": "/2/myanmar/yangon/",
          "label": "ヤンゴン",
          "country_ja": "ミャンマー"
        }
      ],
      "laos": [
        {
          "point_id": "/2/laos/luang-prabang/",
          "label": "ルアンパバン",
          "country_ja": "ラオス人民民主共和国"
        },
        {
          "point_id": "/2/laos/vientiane/",
          "label": "ヴィエンチャン",
          "country_ja": "ラオス人民民主共和国"
        }
      ],
      "east-timor": [
        {
          "point_id": "/2/east-timor/dili/",
          "label": "ディリ",
          "country_ja": "東ティモール民主共和国"
        }
      ]
    }
  },
  "5": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "iceland",
        "label": "アイスランド"
      },
      {
        "country_id": "ireland",
        "label": "アイルランド"
      },
      {
        "country_id": "azerbaijan",
        "label": "アゼルバイジャン"
      },
      {
        "country_id": "albania",
        "label": "アルバニア"
      },
      {
        "country_id": "armenia",
        "label": "アルメニア"
      },
      {
        "country_id": "uk",
        "label": "イギリス"
      },
      {
        "country_id": "italy",
        "label": "イタリア"
      },
      {
        "country_id": "ukraine",
        "label": "ウクライナ"
      },
      {
        "country_id": "estonia",
        "label": "エストニア"
      },
      {
        "country_id": "netherlands",
        "label": "オランダ"
      },
      {
        "country_id": "austria",
        "label": "オーストリア"
      },
      {
        "country_id": "greece",
        "label": "ギリシャ"
      },
      {
        "country_id": "croatia",
        "label": "クロアチア"
      },
      {
        "country_id": "kosovo",
        "label": "コソボ"
      },
      {
        "country_id": "san-marino",
        "label": "サンマリノ共和国"
      },
      {
        "country_id": "gibraltar",
        "label": "ジブラルタル"
      },
      {
        "country_id": "georgia",
        "label": "ジョージア"
      },
      {
        "country_id": "switzerland",
        "label": "スイス"
      },
      {
        "country_id": "sweden",
        "label": "スウェーデン"
      },
      {
        "country_id": "spain",
        "label": "スペイン"
      },
      {
        "country_id": "slovakia",
        "label": "スロバキア"
      },
      {
        "country_id": "slovenia",
        "label": "スロベニア共和国"
      },
      {
        "country_id": "serbia",
        "label": "セルビア"
      },
      {
        "country_id": "czech",
        "label": "チェコ"
      },
      {
        "country_id": "denmark",
        "label": "デンマーク"
      },
      {
        "country_id": "germany",
        "label": "ドイツ"
      },
      {
        "country_id": "norway",
        "label": "ノルウェー"
      },
      {
        "country_id": "hungary",
        "label": "ハンガリー"
      },
      {
        "country_id": "vatican-city",
        "label": "バチカン市国"
      },
      {
        "country_id": "finland",
        "label": "フィンランド"
      },
      {
        "country_id": "france",
        "label": "フランス"
      },
      {
        "country_id": "bulgaria",
        "label": "ブルガリア"
      },
      {
        "country_id": "belarus",
        "label": "ベラルーシ"
      },
      {
        "country_id": "belgium",
        "label": "ベルギー"
      },
      {
        "country_id": "bosnia-and-herzegovina",
        "label": "ボスニア・ヘルツェゴビナ"
      },
      {
        "country_id": "portugal",
        "label": "ポルトガル"
      },
      {
        "country_id": "poland",
        "label": "ポーランド"
      },
      {
        "country_id": "malta",
        "label": "マルタ"
      },
      {
        "country_id": "monaco",
        "label": "モナコ公国"
      },
      {
        "country_id": "moldova",
        "label": "モルドバ"
      },
      {
        "country_id": "montenegro",
        "label": "モンテネグロ"
      },
      {
        "country_id": "latvia",
        "label": "ラトビア"
      },
      {
        "country_id": "lithuania",
        "label": "リトアニア"
      },
      {
        "country_id": "liechtenstein",
        "label": "リヒテンシュタイン"
      },
      {
        "country_id": "luxembourg",
        "label": "ルクセンブルク"
      },
      {
        "country_id": "romania",
        "label": "ルーマニア"
      },
      {
        "country_id": "russia",
        "label": "ロシア"
      },
      {
        "country_id": "north-macedonia",
        "label": "北マケドニア"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/5/germany/eisenach/",
          "label": "アイゼナッハ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/spain/ainsa/",
          "label": "アインサ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/germany/augsburg/",
          "label": "アウクスブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/iceland/akureyri/",
          "label": "アクレイリ",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/italy/agrigento/",
          "label": "アグリジェント",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/france/ajaccio/",
          "label": "アジャクシオ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/greece/athens/",
          "label": "アテネ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/italy/anacapri/",
          "label": "アナカプリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/uk/aberdeen/",
          "label": "アバディーン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/aviemore/",
          "label": "アビーモア",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/netherlands/apeldoorn/",
          "label": "アペルドールン",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/italy/amalfi/",
          "label": "アマルフィ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/netherlands/amsterdam/",
          "label": "アムステルダム",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/romania/arad/",
          "label": "アラド",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/norway/alta/",
          "label": "アルタ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/spain/algeciras/",
          "label": "アルヘシラス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/italy/alberobello/",
          "label": "アルベロベッロ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/france/arles/",
          "label": "アルル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/italy/ancona/",
          "label": "アンコーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/anterselva/",
          "label": "アンテルセルヴァ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/switzerland/andermatt/",
          "label": "アンデルマット",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/belgium/antwerpen/",
          "label": "アントウェルペン",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/france/avignon/",
          "label": "アヴィニヨン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/portugal/aveiro/",
          "label": "アヴェイロ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/germany/aachen/",
          "label": "アーヘン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/greece/oia/",
          "label": "イア（サントリーニ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/ireland/inishmore/",
          "label": "イニシュモア",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/malta/mdina/",
          "label": "イムディーナ",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/greece/iraklion/",
          "label": "イラクリオン（クレタ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/austria/innsbruck/",
          "label": "インスブルック",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/switzerland/interlaken/",
          "label": "インターラーケン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/finland/ivalo/",
          "label": "イヴァロ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/iceland/isafjorour/",
          "label": "イーサフィヨルズル",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/uk/windsor/",
          "label": "ウィンザー ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/windermere/",
          "label": "ウィンダミア",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/austria/vienna/",
          "label": "ウィーン",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/poland/lodz/",
          "label": "ウッチ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/italy/udine/",
          "label": "ウディネ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/russia/vladivostok/",
          "label": "ウラジオストク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/yekaterinburg/",
          "label": "エカテリンブルグ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/hungary/eger/",
          "label": "エゲル",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/sweden/ostersund/",
          "label": "エステルスンド",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/uk/edinburgh/",
          "label": "エディンバラ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/france/evian-les-bains/",
          "label": "エビアン・レ・バン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/portugal/evora/",
          "label": "エボラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/germany/emden/",
          "label": "エムデン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/armenia/yerevan/",
          "label": "エレバン",
          "country_ja": "アルメニア"
        },
        {
          "point_id": "/5/italy/enna/",
          "label": "エンナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/russia/oymyakon/",
          "label": "オイミヤコン",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/czech/ostrava/",
          "label": "オストラバ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/norway/oslo/",
          "label": "オスロ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/netherlands/otterloo/",
          "label": "オッテルロー",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/ukraine/odessa/",
          "label": "オデーサ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/portugal/obidos/",
          "label": "オビドス",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/russia/omsk/",
          "label": "オムスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/greece/ornos/",
          "label": "オルノス（ミコノス島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/france/honfleur/",
          "label": "オンフルール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/denmark/odense/",
          "label": "オーゼンセ",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/aarhus/",
          "label": "オーフス",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/lithuania/kaunas/",
          "label": "カウナス",
          "country_ja": "リトアニア"
        },
        {
          "point_id": "/5/russia/kazan/",
          "label": "カザン",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/bulgaria/kazanlak/",
          "label": "カザンルク",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/spain/castello-de-la-plana/",
          "label": "カステリョン・デ・ラ・プラナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/greece/katakolon/",
          "label": "カタコロン",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/italy/catania/",
          "label": "カターニア",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/germany/kassel/",
          "label": "カッセル",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/poland/katowice/",
          "label": "カトビーツェ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/italy/capri/",
          "label": "カプリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/uk/camborne/",
          "label": "カムボーン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/greece/kalamabaka/",
          "label": "カランバカ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/italy/cagliari/",
          "label": "カリアリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/russia/kaliningrad/",
          "label": "カリーニングラード",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/france/carcassonne/",
          "label": "カルカッソンヌ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/sweden/kalmar/",
          "label": "カルマル",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/france/cannes/",
          "label": "カンヌ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/uk/cardiff/",
          "label": "カーディフ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/sweden/karlstad/",
          "label": "カールスタード",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/france/caen/",
          "label": "カーン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/moldova/chisinau/",
          "label": "キシナウ",
          "country_ja": "モルドバ"
        },
        {
          "point_id": "/5/iceland/kirkvayel-croistol/",
          "label": "キルキュヴァイエルクロイストル",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/ireland/kilkenny/",
          "label": "キルケニー",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/norway/kirkenes/",
          "label": "キルケネス",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/sweden/kiruna/",
          "label": "キルナ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/netherlands/kinderdijk/",
          "label": "キンデルダイク",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/ukraine/kiev/",
          "label": "キーウ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/portugal/guimaraes/",
          "label": "ギマラインス",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/spain/cuenca/",
          "label": "クエンカ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/lithuania/klaipeda/",
          "label": "クライペダ",
          "country_ja": "リトアニア"
        },
        {
          "point_id": "/5/poland/krakow/",
          "label": "クラクフ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/russia/krasnodar/",
          "label": "クラスノダール",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/serbia/kraljevo/",
          "label": "クラリエボ",
          "country_ja": "セルビア"
        },
        {
          "point_id": "/5/ukraine/kryvyi-rih/",
          "label": "クルィヴィーイ・リーフ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/poland/gdansk/",
          "label": "グダニスク",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/uk/glasgow/",
          "label": "グラスゴー",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/spain/granada/",
          "label": "グラナダ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/austria/graz/",
          "label": "グラーツ",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/switzerland/gruyeres/",
          "label": "グリュイエール",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/iceland/grindavik/",
          "label": "グリンダヴィーク",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/switzerland/grindelwald/",
          "label": "グリンデルワルド",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/iceland/keflavik/",
          "label": "ケフラビーク",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/finland/kemi/",
          "label": "ケミ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/germany/cologne/",
          "label": "ケルン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/kempten-allgaeu/",
          "label": "ケンプテン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/norway/geiranger/",
          "label": "ゲイランゲル",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/belgium/ghent/",
          "label": "ゲント",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/portugal/coimbra/",
          "label": "コインブラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/slovakia/kosice/",
          "label": "コシツェ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/denmark/copenhagen/",
          "label": "コペンハーゲン",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/ireland/cork/",
          "label": "コルク",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/italy/cortina-dampezzo/",
          "label": "コルティナダンペッツオ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/spain/cordoba/",
          "label": "コルドバ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/france/colmar/",
          "label": "コルマール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/ireland/cong/",
          "label": "コング",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/spain/consuegra/",
          "label": "コンスエグラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/romania/constanta/",
          "label": "コンスタンツァ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/ireland/galway/",
          "label": "ゴールウェイ",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/uk/cirencester/",
          "label": "サイレンセスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/russia/samara/",
          "label": "サマーラ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/bosnia-and-herzegovina/sarajevo/",
          "label": "サラエボ",
          "country_ja": "ボスニア・ヘルツェゴビナ"
        },
        {
          "point_id": "/5/spain/zaragoza/",
          "label": "サラゴサ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/salamanca/",
          "label": "サラマンカ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/russia/saint-petersburg/",
          "label": "サンクトペテルブルク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/malta/saint-julian/",
          "label": "サンジュリアン",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/spain/santiago-de-compostela/",
          "label": "サンティアゴ・デ・コンポステーラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/france/saint-denis/",
          "label": "サンドニ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/san-marino/san-marino/",
          "label": "サンマリノ",
          "country_ja": "サンマリノ共和国"
        },
        {
          "point_id": "/5/spain/san-sebastian/",
          "label": "サン・セバスチャン",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/switzerland/stmoritz/",
          "label": "サン・モリッツ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/saas-fee/",
          "label": "サースフェー",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/finland/saariselka/",
          "label": "サーリセルカ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/croatia/zagreb/",
          "label": "ザグレブ",
          "country_ja": "クロアチア"
        },
        {
          "point_id": "/5/poland/zamosc/",
          "label": "ザモシチ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/austria/salzburg/",
          "label": "ザルツブルク",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/switzerland/st-gallen/",
          "label": "ザンクトガレン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/austria/sankt-wolfgang/",
          "label": "ザンクトヴォルフガング",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/italy/siena/",
          "label": "シエナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/romania/sighisoara/",
          "label": "シギショアラ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/sinaia/",
          "label": "シナイア",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/sibiu/",
          "label": "シビウ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/france/chamonix/",
          "label": "シャモニー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/chartres/",
          "label": "シャルトル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/germany/stuttgart/",
          "label": "シュトゥットガルト",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/schleswig/",
          "label": "シュレースビヒ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/hungary/sopron/",
          "label": "ショプロン",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/italy/siracusa/",
          "label": "シラクサ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/portugal/sintra/",
          "label": "シントラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/italy/genoa/",
          "label": "ジェノバ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/hungary/gyor/",
          "label": "ジェール",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/gibraltar/gibraltar/",
          "label": "ジブラルタル",
          "country_ja": "ジブラルタル"
        },
        {
          "point_id": "/5/switzerland/geneve/",
          "label": "ジュネーブ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/slovakia/zilina/",
          "label": "ジリナ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/france/giverny/",
          "label": "ジヴェルニー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/north-macedonia/skopje/",
          "label": "スコピエ",
          "country_ja": "北マケドニア"
        },
        {
          "point_id": "/5/norway/stavanger/",
          "label": "スタバンゲル",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/sweden/stockholm/",
          "label": "ストックホルム",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/france/strasbourg/",
          "label": "ストラスブール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/uk/stratford-upon-avon/",
          "label": "ストラトフォードアポンエイボン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/croatia/split/",
          "label": "スプリット",
          "country_ja": "クロアチア"
        },
        {
          "point_id": "/5/ireland/sligo/",
          "label": "スライゴ",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/bulgaria/sliven/",
          "label": "スリベン",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/spain/segovia/",
          "label": "セゴビア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/sevilla/",
          "label": "セビリヤ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/iceland/serfoss/",
          "label": "セルフォス",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/austria/seefeld/",
          "label": "ゼーフェルト",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/finland/sodankyla/",
          "label": "ソダンキュラ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/russia/sochi/",
          "label": "ソチ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/bulgaria/sofia/",
          "label": "ソフィア",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/sweden/sollebrunn/",
          "label": "ソレンチューナ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/uk/tiree/",
          "label": "タイリー島",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/italy/taormina/",
          "label": "タオルミーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/spain/tarragona/",
          "label": "タラゴナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/tarifa/",
          "label": "タリファ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/estonia/tallinn/",
          "label": "タリン",
          "country_ja": "エストニア"
        },
        {
          "point_id": "/5/finland/tampere/",
          "label": "タンペレ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/latvia/daugavpils/",
          "label": "ダウガフピールス",
          "country_ja": "ラトビア"
        },
        {
          "point_id": "/5/ireland/dublin/",
          "label": "ダブリン",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/czech/cesky-krumlov/",
          "label": "チェスキークルムロフ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/uk/chester/",
          "label": "チェスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/poland/czestochowa/",
          "label": "チェストホバ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/russia/chelyabinsk/",
          "label": "チェリャビンスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/ukraine/chernivtsi/",
          "label": "チェルニウツィー",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/uk/chipping-campden/",
          "label": "チッピングカムデン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/switzerland/zurich/",
          "label": "チューリヒ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/austria/zell-am-see/",
          "label": "ツェルアムゼー",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/switzerland/zermatt/",
          "label": "ツェルマット",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/albania/tirana/",
          "label": "ティラナ",
          "country_ja": "アルバニア"
        },
        {
          "point_id": "/5/greece/thessaloniki/",
          "label": "テッサロニキ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/switzerland/tasch/",
          "label": "テーシュ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/italy/tesero/",
          "label": "テーゼロ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/france/dijon/",
          "label": "ディジョン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/belgium/dinant/",
          "label": "ディナン",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/germany/dusseldorf/",
          "label": "デュッセルドルフ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/belgium/durbuy/",
          "label": "デュルビュイ",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/austria/durnstein/",
          "label": "デュルンシュタイン",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/netherlands/delft/",
          "label": "デルフト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/finland/turku/",
          "label": "トゥルク",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/russia/tula/",
          "label": "トゥーラ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/france/tours/",
          "label": "トゥール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/toulouse/",
          "label": "トゥールーズ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/georgia/tbilisi/",
          "label": "トビリシ",
          "country_ja": "ジョージア"
        },
        {
          "point_id": "/5/italy/trapani/",
          "label": "トラパニ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/turin/",
          "label": "トリノ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/sweden/torup/",
          "label": "トルップ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/poland/torun/",
          "label": "トルニ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/spain/toledo/",
          "label": "トレド",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/norway/tromso/",
          "label": "トロムソ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/trondheim/",
          "label": "トロンヘイム",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/hungary/dunaujvaros/",
          "label": "ドゥナウーイバーロシュ",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/croatia/dubrovnik/",
          "label": "ドゥブロブニク",
          "country_ja": "クロアチア"
        },
        {
          "point_id": "/5/germany/dresden/",
          "label": "ドレスデン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/portugal/nazare/",
          "label": "ナザレ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/hungary/nagykanizsa/",
          "label": "ナジカニジャ",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/italy/napoli/",
          "label": "ナポリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/belgium/namur/",
          "label": "ナミュール",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/france/nancy/",
          "label": "ナンシー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/nantes/",
          "label": "ナント",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/finland/naantali/",
          "label": "ナーンタリ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/serbia/nis/",
          "label": "ニシュ",
          "country_ja": "セルビア"
        },
        {
          "point_id": "/5/germany/nuremberg/",
          "label": "ニュルンベルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/russia/nizhniy-novgorod/",
          "label": "ニージニー・ノブゴロド",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/france/nice/",
          "label": "ニース",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/denmark/nuuk/",
          "label": "ヌーク",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/germany/nordlingen/",
          "label": "ネルトリンゲン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/russia/novosibirsk/",
          "label": "ノボシビールスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/germany/heidelberg/",
          "label": "ハイデルベルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/austria/hall-in-tirol/",
          "label": "ハイリンゲンフルート",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/belgium/hasselt/",
          "label": "ハッセルト",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/greece/chania/",
          "label": "ハニア（クレタ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/germany/hannover/",
          "label": "ハノーファー",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/russia/khabarovsk/",
          "label": "ハバロフスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/austria/hallstatt/",
          "label": "ハルシュタット",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/germany/hamburg/",
          "label": "ハンブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/netherlands/den-haag/",
          "label": "ハーグ",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/azerbaijan/baku/",
          "label": "バクー",
          "country_ja": "アゼルバイジャン"
        },
        {
          "point_id": "/5/portugal/batalha/",
          "label": "バターリャ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/vatican-city/vatican-city/",
          "label": "バチカン市国",
          "country_ja": "バチカン市国"
        },
        {
          "point_id": "/5/spain/barcelona/",
          "label": "バルセロナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/bulgaria/varna/",
          "label": "バルナ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/malta/valletta/",
          "label": "バレッタ（マルタ島）",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/spain/valencia/",
          "label": "バレンシア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/slovakia/banska-bystrica/",
          "label": "バンスカービストリツァ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/uk/bath/",
          "label": "バース",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/birmingham/",
          "label": "バーミンガム",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/italy/bari/",
          "label": "バーリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/greece/patra/",
          "label": "パトラ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/sweden/pajala/",
          "label": "パヤラ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/france/paris/",
          "label": "パリ（Paris）",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/spain/palma/",
          "label": "パルマ（マヨルカ島）",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/italy/palermo/",
          "label": "パレルモ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/pantelleria/",
          "label": "パンテレリーア島",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/spain/pamplona/",
          "label": "パンプローナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/malta/victoria/",
          "label": "ビクトリア（ゴゾ島）",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/denmark/vejle/",
          "label": "ビランド",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/lithuania/vilnius/",
          "label": "ビリニュス",
          "country_ja": "リトアニア"
        },
        {
          "point_id": "/5/spain/bilbao/",
          "label": "ビルバオ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/italy/pisa/",
          "label": "ピサ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/portugal/fatima/",
          "label": "ファティマ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/liechtenstein/vaduz/",
          "label": "ファドゥーツ",
          "country_ja": "リヒテンシュタイン"
        },
        {
          "point_id": "/5/norway/fagernes/",
          "label": "ファーゲルネス",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/spain/fisterra/",
          "label": "フィステーラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/greece/fira/",
          "label": "フィラ（サントリーニ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/italy/florence/",
          "label": "フィレンツェ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/germany/fussen/",
          "label": "フュッセン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/frankfurt-am-main/",
          "label": "フランクフルト",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/norway/flam/",
          "label": "フロム",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/portugal/funchal/",
          "label": "フンシャル（マデイラ諸島）",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/romania/bucharest/",
          "label": "ブカレスト",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/buzau/",
          "label": "ブザウ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/hungary/budapest/",
          "label": "ブダペスト",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/romania/brasov/",
          "label": "ブラショフ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/slovakia/bratislava/",
          "label": "ブラティスラバ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/uk/bridlington/",
          "label": "ブリッドリントン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/belgium/brussels/",
          "label": "ブリュッセル",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/italy/brindisi/",
          "label": "ブリンディジ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/spain/burgos/",
          "label": "ブルゴス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/czech/brno/",
          "label": "ブルノ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/belgium/bruges/",
          "label": "ブルージュ",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belarus/brest/",
          "label": "ブレスト",
          "country_ja": "ベラルーシ"
        },
        {
          "point_id": "/5/france/brest/",
          "label": "ブレスト",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/germany/bremen/",
          "label": "ブレーメン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/poland/wroclaw/",
          "label": "ブロツワフ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/france/bourges/",
          "label": "ブールジュ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/greece/platis-gialos/",
          "label": "プラティス・ヤロス",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/czech/prague/",
          "label": "プラハ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/montenegro/pljevlja/",
          "label": "プリエプリャ",
          "country_ja": "モンテネグロ"
        },
        {
          "point_id": "/5/kosovo/pristina/",
          "label": "プリシュティナ",
          "country_ja": "コソボ"
        },
        {
          "point_id": "/5/slovakia/presov/",
          "label": "プレショフ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/italy/predazzo/",
          "label": "プレダッツォ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/bulgaria/plovdiv/",
          "label": "プロブディフ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/iceland/hetra/",
          "label": "ヘトラ",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/finland/helsinki/",
          "label": "ヘルシンキ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/sweden/helsingborg/",
          "label": "ヘルシンボリ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/serbia/belgrade/",
          "label": "ベオグラード",
          "country_ja": "セルビア"
        },
        {
          "point_id": "/5/bulgaria/veliko-tarnovo/",
          "label": "ベリコタルノボ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/norway/bergen/",
          "label": "ベルゲン",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/uk/belfast/",
          "label": "ベルファスト",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/germany/berlin/",
          "label": "ベルリン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/switzerland/bern/",
          "label": "ベルン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/france/perpignan/",
          "label": "ペルピニャン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/hungary/pecs/",
          "label": "ペーチ",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/norway/honningsvag/",
          "label": "ホニングスヴォーグ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/belarus/gomel/",
          "label": "ホメリ",
          "country_ja": "ベラルーシ"
        },
        {
          "point_id": "/5/russia/volgograd/",
          "label": "ボルゴグラード",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/france/bordeaux/",
          "label": "ボルドー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/italy/bormio/",
          "label": "ボルミオ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/russia/voronezh/",
          "label": "ボロネシ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/germany/bonn/",
          "label": "ボン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/norway/bodo/",
          "label": "ボーデ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/poland/poznan/",
          "label": "ポズナニ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/montenegro/podgorica/",
          "label": "ポドゴリツァ",
          "country_ja": "モンテネグロ"
        },
        {
          "point_id": "/5/ukraine/poltava/",
          "label": "ポルタヴァ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/portugal/porto/",
          "label": "ポルト",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/finland/porvoo/",
          "label": "ポルヴォー",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/italy/pompeii/",
          "label": "ポンペイ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/switzerland/maienfeld/",
          "label": "マイエンフェルト",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/germany/meissen/",
          "label": "マイセン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/italy/matera/",
          "label": "マテーラ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/spain/madrid/",
          "label": "マドリード",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/malaga/",
          "label": "マラガ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/slovenia/maribor/",
          "label": "マリボル",
          "country_ja": "スロベニア共和国"
        },
        {
          "point_id": "/5/malta/marsaxlokk/",
          "label": "マルサックスロック",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/france/marseille/",
          "label": "マルセイユ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/sweden/malmo/",
          "label": "マルメ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/uk/manchester/",
          "label": "マンチェスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/netherlands/maastricht/",
          "label": "マーストリヒト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/greece/mykonos-town/",
          "label": "ミコノスタウン",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/spain/mijas/",
          "label": "ミハス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/germany/munich/",
          "label": "ミュンヘン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/norway/myrdal/",
          "label": "ミュールダール",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/italy/milano/",
          "label": "ミラノ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/belarus/minsk/",
          "label": "ミンスク",
          "country_ja": "ベラルーシ"
        },
        {
          "point_id": "/5/spain/murcia/",
          "label": "ムルシア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/italy/messina/",
          "label": "メッシーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/belgium/mechelen/",
          "label": "メッヘレン",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/austria/melk/",
          "label": "メルク",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/russia/moscow/",
          "label": "モスクワ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/monaco/monaco/",
          "label": "モナコ",
          "country_ja": "モナコ公国"
        },
        {
          "point_id": "/5/switzerland/montreux/",
          "label": "モントルー",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/france/montpellier/",
          "label": "モンペリエ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/russia/yakutsk/",
          "label": "ヤクーツク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/romania/iasi/",
          "label": "ヤーシ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/netherlands/utrecht/",
          "label": "ユトレヒト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/finland/jokioinen/",
          "label": "ヨキオイネン",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/sweden/gothenburg/",
          "label": "ヨーテボリ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/germany/leipzig/",
          "label": "ライプツィヒ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/malta/rabat/",
          "label": "ラバト",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/france/reims/",
          "label": "ランス",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/latvia/liepaja/",
          "label": "リエパヤ",
          "country_ja": "ラトビア"
        },
        {
          "point_id": "/5/latvia/riga/",
          "label": "リガ",
          "country_ja": "ラトビア"
        },
        {
          "point_id": "/5/portugal/lisbon/",
          "label": "リスボン",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/netherlands/lisse/",
          "label": "リッセ",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/uk/liverpool/",
          "label": "リバプール",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/france/limoges/",
          "label": "リモージュ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/slovenia/ljubljana/",
          "label": "リュブリャナ",
          "country_ja": "スロベニア共和国"
        },
        {
          "point_id": "/5/germany/rudesheim/",
          "label": "リューデスハイム",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/france/lyon/",
          "label": "リヨン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/sweden/linkoping/",
          "label": "リンシェピング",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/austria/linz/",
          "label": "リンツ",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/italy/livigno/",
          "label": "リヴィーニョ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/uk/leeds/",
          "label": "リーズ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/france/lille/",
          "label": "リール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/luxembourg/luxembourg/",
          "label": "ルクセンブルク",
          "country_ja": "ルクセンブルク"
        },
        {
          "point_id": "/5/bulgaria/ruse/",
          "label": "ルセ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/switzerland/lucerne/",
          "label": "ルツェルン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/france/lourdes/",
          "label": "ルルド",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/le-havre/",
          "label": "ル・アーヴル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/rouen/",
          "label": "ルーアン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/iceland/reykjavik/",
          "label": "レイキャビク",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/spain/leon/",
          "label": "レオン",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/france/rennes/",
          "label": "レンヌ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/netherlands/leeuwarden/",
          "label": "レーワルデン",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/denmark/roskilde/",
          "label": "ロスキレ",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/russia/rostov/",
          "label": "ロストフ・ナ・ドヌー",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/ireland/rosslare/",
          "label": "ロスレア",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/netherlands/rotterdam/",
          "label": "ロッテルダム",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/finland/rovaniemi/",
          "label": "ロバニエミ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/norway/longyearbyen/",
          "label": "ロングイェールビーン（スバールバル諸島）",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/spain/ronda/",
          "label": "ロンダ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/uk/london/",
          "label": "ロンドン（London）",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/switzerland/lausanne/",
          "label": "ローザンヌ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/germany/rothenburg/",
          "label": "ローテンブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/greece/rodos/",
          "label": "ロードス",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/italy/rome/",
          "label": "ローマ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/germany/weimar/",
          "label": "ワイマール",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/poland/warsaw/",
          "label": "ワルシャワ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/wieliczka/",
          "label": "ヴィエリチカ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/portugal/santa-maria/",
          "label": "ヴィーラ・ド・ポルト（サンタマリア島）",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/porto-santo/",
          "label": "ヴィーラ・バレイラ（ポルトサント島）",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/italy/venice/",
          "label": "ヴェネツィア",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/verona/",
          "label": "ヴェローナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/norway/vossevangen/",
          "label": "ヴォス",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/germany/wurzburg/",
          "label": "ヴュルツブルク",
          "country_ja": "ドイツ"
        }
      ],
      "iceland": [
        {
          "point_id": "/5/iceland/akureyri/",
          "label": "アクレイリ",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/isafjorour/",
          "label": "イーサフィヨルズル",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/kirkvayel-croistol/",
          "label": "キルキュヴァイエルクロイストル",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/grindavik/",
          "label": "グリンダヴィーク",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/keflavik/",
          "label": "ケフラビーク",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/serfoss/",
          "label": "セルフォス",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/hetra/",
          "label": "ヘトラ",
          "country_ja": "アイスランド"
        },
        {
          "point_id": "/5/iceland/reykjavik/",
          "label": "レイキャビク",
          "country_ja": "アイスランド"
        }
      ],
      "ireland": [
        {
          "point_id": "/5/ireland/inishmore/",
          "label": "イニシュモア",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/kilkenny/",
          "label": "キルケニー",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/cork/",
          "label": "コルク",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/cong/",
          "label": "コング",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/galway/",
          "label": "ゴールウェイ",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/sligo/",
          "label": "スライゴ",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/dublin/",
          "label": "ダブリン",
          "country_ja": "アイルランド"
        },
        {
          "point_id": "/5/ireland/rosslare/",
          "label": "ロスレア",
          "country_ja": "アイルランド"
        }
      ],
      "albania": [
        {
          "point_id": "/5/albania/tirana/",
          "label": "ティラナ",
          "country_ja": "アルバニア"
        }
      ],
      "uk": [
        {
          "point_id": "/5/uk/aberdeen/",
          "label": "アバディーン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/aviemore/",
          "label": "アビーモア",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/windsor/",
          "label": "ウィンザー ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/windermere/",
          "label": "ウィンダミア",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/edinburgh/",
          "label": "エディンバラ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/camborne/",
          "label": "カムボーン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/cardiff/",
          "label": "カーディフ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/glasgow/",
          "label": "グラスゴー",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/cirencester/",
          "label": "サイレンセスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/stratford-upon-avon/",
          "label": "ストラトフォードアポンエイボン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/tiree/",
          "label": "タイリー島",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/chester/",
          "label": "チェスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/chipping-campden/",
          "label": "チッピングカムデン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/bath/",
          "label": "バース",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/birmingham/",
          "label": "バーミンガム",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/bridlington/",
          "label": "ブリッドリントン",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/belfast/",
          "label": "ベルファスト",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/manchester/",
          "label": "マンチェスター",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/liverpool/",
          "label": "リバプール",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/leeds/",
          "label": "リーズ",
          "country_ja": "イギリス"
        },
        {
          "point_id": "/5/uk/london/",
          "label": "ロンドン（London）",
          "country_ja": "イギリス"
        }
      ],
      "italy": [
        {
          "point_id": "/5/italy/agrigento/",
          "label": "アグリジェント",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/anacapri/",
          "label": "アナカプリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/amalfi/",
          "label": "アマルフィ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/alberobello/",
          "label": "アルベロベッロ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/ancona/",
          "label": "アンコーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/anterselva/",
          "label": "アンテルセルヴァ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/udine/",
          "label": "ウディネ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/enna/",
          "label": "エンナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/catania/",
          "label": "カターニア",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/capri/",
          "label": "カプリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/cagliari/",
          "label": "カリアリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/cortina-dampezzo/",
          "label": "コルティナダンペッツオ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/siena/",
          "label": "シエナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/siracusa/",
          "label": "シラクサ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/genoa/",
          "label": "ジェノバ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/taormina/",
          "label": "タオルミーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/tesero/",
          "label": "テーゼロ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/trapani/",
          "label": "トラパニ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/turin/",
          "label": "トリノ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/napoli/",
          "label": "ナポリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/bari/",
          "label": "バーリ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/palermo/",
          "label": "パレルモ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/pantelleria/",
          "label": "パンテレリーア島",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/pisa/",
          "label": "ピサ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/florence/",
          "label": "フィレンツェ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/brindisi/",
          "label": "ブリンディジ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/predazzo/",
          "label": "プレダッツォ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/bormio/",
          "label": "ボルミオ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/pompeii/",
          "label": "ポンペイ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/matera/",
          "label": "マテーラ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/milano/",
          "label": "ミラノ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/messina/",
          "label": "メッシーナ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/livigno/",
          "label": "リヴィーニョ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/rome/",
          "label": "ローマ",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/venice/",
          "label": "ヴェネツィア",
          "country_ja": "イタリア"
        },
        {
          "point_id": "/5/italy/verona/",
          "label": "ヴェローナ",
          "country_ja": "イタリア"
        }
      ],
      "ukraine": [
        {
          "point_id": "/5/ukraine/odessa/",
          "label": "オデーサ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/ukraine/kiev/",
          "label": "キーウ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/ukraine/kryvyi-rih/",
          "label": "クルィヴィーイ・リーフ",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/ukraine/chernivtsi/",
          "label": "チェルニウツィー",
          "country_ja": "ウクライナ"
        },
        {
          "point_id": "/5/ukraine/poltava/",
          "label": "ポルタヴァ",
          "country_ja": "ウクライナ"
        }
      ],
      "estonia": [
        {
          "point_id": "/5/estonia/tallinn/",
          "label": "タリン",
          "country_ja": "エストニア"
        }
      ],
      "netherlands": [
        {
          "point_id": "/5/netherlands/apeldoorn/",
          "label": "アペルドールン",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/amsterdam/",
          "label": "アムステルダム",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/otterloo/",
          "label": "オッテルロー",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/kinderdijk/",
          "label": "キンデルダイク",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/delft/",
          "label": "デルフト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/den-haag/",
          "label": "ハーグ",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/maastricht/",
          "label": "マーストリヒト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/utrecht/",
          "label": "ユトレヒト",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/lisse/",
          "label": "リッセ",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/leeuwarden/",
          "label": "レーワルデン",
          "country_ja": "オランダ"
        },
        {
          "point_id": "/5/netherlands/rotterdam/",
          "label": "ロッテルダム",
          "country_ja": "オランダ"
        }
      ],
      "austria": [
        {
          "point_id": "/5/austria/innsbruck/",
          "label": "インスブルック",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/vienna/",
          "label": "ウィーン",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/graz/",
          "label": "グラーツ",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/salzburg/",
          "label": "ザルツブルク",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/sankt-wolfgang/",
          "label": "ザンクトヴォルフガング",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/seefeld/",
          "label": "ゼーフェルト",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/zell-am-see/",
          "label": "ツェルアムゼー",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/durnstein/",
          "label": "デュルンシュタイン",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/hall-in-tirol/",
          "label": "ハイリンゲンフルート",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/hallstatt/",
          "label": "ハルシュタット",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/melk/",
          "label": "メルク",
          "country_ja": "オーストリア"
        },
        {
          "point_id": "/5/austria/linz/",
          "label": "リンツ",
          "country_ja": "オーストリア"
        }
      ],
      "north-macedonia": [
        {
          "point_id": "/5/north-macedonia/skopje/",
          "label": "スコピエ",
          "country_ja": "北マケドニア"
        }
      ],
      "greece": [
        {
          "point_id": "/5/greece/athens/",
          "label": "アテネ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/oia/",
          "label": "イア（サントリーニ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/iraklion/",
          "label": "イラクリオン（クレタ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/ornos/",
          "label": "オルノス（ミコノス島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/katakolon/",
          "label": "カタコロン",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/kalamabaka/",
          "label": "カランバカ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/thessaloniki/",
          "label": "テッサロニキ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/chania/",
          "label": "ハニア（クレタ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/patra/",
          "label": "パトラ",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/fira/",
          "label": "フィラ（サントリーニ島）",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/platis-gialos/",
          "label": "プラティス・ヤロス",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/mykonos-town/",
          "label": "ミコノスタウン",
          "country_ja": "ギリシャ"
        },
        {
          "point_id": "/5/greece/rodos/",
          "label": "ロードス",
          "country_ja": "ギリシャ"
        }
      ],
      "croatia": [
        {
          "point_id": "/5/croatia/zagreb/",
          "label": "ザグレブ",
          "country_ja": "クロアチア"
        },
        {
          "point_id": "/5/croatia/split/",
          "label": "スプリット",
          "country_ja": "クロアチア"
        },
        {
          "point_id": "/5/croatia/dubrovnik/",
          "label": "ドゥブロブニク",
          "country_ja": "クロアチア"
        }
      ],
      "gibraltar": [
        {
          "point_id": "/5/gibraltar/gibraltar/",
          "label": "ジブラルタル",
          "country_ja": "ジブラルタル"
        }
      ],
      "switzerland": [
        {
          "point_id": "/5/switzerland/andermatt/",
          "label": "アンデルマット",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/interlaken/",
          "label": "インターラーケン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/gruyeres/",
          "label": "グリュイエール",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/grindelwald/",
          "label": "グリンデルワルド",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/stmoritz/",
          "label": "サン・モリッツ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/saas-fee/",
          "label": "サースフェー",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/st-gallen/",
          "label": "ザンクトガレン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/geneve/",
          "label": "ジュネーブ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/zurich/",
          "label": "チューリヒ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/zermatt/",
          "label": "ツェルマット",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/tasch/",
          "label": "テーシュ",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/bern/",
          "label": "ベルン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/maienfeld/",
          "label": "マイエンフェルト",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/montreux/",
          "label": "モントルー",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/lucerne/",
          "label": "ルツェルン",
          "country_ja": "スイス"
        },
        {
          "point_id": "/5/switzerland/lausanne/",
          "label": "ローザンヌ",
          "country_ja": "スイス"
        }
      ],
      "sweden": [
        {
          "point_id": "/5/sweden/ostersund/",
          "label": "エステルスンド",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/kalmar/",
          "label": "カルマル",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/karlstad/",
          "label": "カールスタード",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/kiruna/",
          "label": "キルナ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/stockholm/",
          "label": "ストックホルム",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/sollebrunn/",
          "label": "ソレンチューナ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/torup/",
          "label": "トルップ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/pajala/",
          "label": "パヤラ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/helsingborg/",
          "label": "ヘルシンボリ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/malmo/",
          "label": "マルメ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/gothenburg/",
          "label": "ヨーテボリ",
          "country_ja": "スウェーデン"
        },
        {
          "point_id": "/5/sweden/linkoping/",
          "label": "リンシェピング",
          "country_ja": "スウェーデン"
        }
      ],
      "spain": [
        {
          "point_id": "/5/spain/ainsa/",
          "label": "アインサ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/algeciras/",
          "label": "アルヘシラス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/castello-de-la-plana/",
          "label": "カステリョン・デ・ラ・プラナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/cuenca/",
          "label": "クエンカ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/granada/",
          "label": "グラナダ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/cordoba/",
          "label": "コルドバ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/consuegra/",
          "label": "コンスエグラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/zaragoza/",
          "label": "サラゴサ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/salamanca/",
          "label": "サラマンカ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/santiago-de-compostela/",
          "label": "サンティアゴ・デ・コンポステーラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/san-sebastian/",
          "label": "サン・セバスチャン",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/segovia/",
          "label": "セゴビア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/sevilla/",
          "label": "セビリヤ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/tarragona/",
          "label": "タラゴナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/tarifa/",
          "label": "タリファ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/toledo/",
          "label": "トレド",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/barcelona/",
          "label": "バルセロナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/valencia/",
          "label": "バレンシア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/palma/",
          "label": "パルマ（マヨルカ島）",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/pamplona/",
          "label": "パンプローナ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/bilbao/",
          "label": "ビルバオ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/fisterra/",
          "label": "フィステーラ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/burgos/",
          "label": "ブルゴス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/madrid/",
          "label": "マドリード",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/malaga/",
          "label": "マラガ",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/mijas/",
          "label": "ミハス",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/murcia/",
          "label": "ムルシア",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/leon/",
          "label": "レオン",
          "country_ja": "スペイン"
        },
        {
          "point_id": "/5/spain/ronda/",
          "label": "ロンダ",
          "country_ja": "スペイン"
        }
      ],
      "slovakia": [
        {
          "point_id": "/5/slovakia/kosice/",
          "label": "コシツェ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/slovakia/zilina/",
          "label": "ジリナ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/slovakia/banska-bystrica/",
          "label": "バンスカービストリツァ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/slovakia/bratislava/",
          "label": "ブラティスラバ",
          "country_ja": "スロバキア"
        },
        {
          "point_id": "/5/slovakia/presov/",
          "label": "プレショフ",
          "country_ja": "スロバキア"
        }
      ],
      "serbia": [
        {
          "point_id": "/5/serbia/kraljevo/",
          "label": "クラリエボ",
          "country_ja": "セルビア"
        },
        {
          "point_id": "/5/serbia/nis/",
          "label": "ニシュ",
          "country_ja": "セルビア"
        },
        {
          "point_id": "/5/serbia/belgrade/",
          "label": "ベオグラード",
          "country_ja": "セルビア"
        }
      ],
      "czech": [
        {
          "point_id": "/5/czech/ostrava/",
          "label": "オストラバ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/czech/cesky-krumlov/",
          "label": "チェスキークルムロフ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/czech/brno/",
          "label": "ブルノ",
          "country_ja": "チェコ"
        },
        {
          "point_id": "/5/czech/prague/",
          "label": "プラハ",
          "country_ja": "チェコ"
        }
      ],
      "denmark": [
        {
          "point_id": "/5/denmark/odense/",
          "label": "オーゼンセ",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/aarhus/",
          "label": "オーフス",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/copenhagen/",
          "label": "コペンハーゲン",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/nuuk/",
          "label": "ヌーク",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/vejle/",
          "label": "ビランド",
          "country_ja": "デンマーク"
        },
        {
          "point_id": "/5/denmark/roskilde/",
          "label": "ロスキレ",
          "country_ja": "デンマーク"
        }
      ],
      "germany": [
        {
          "point_id": "/5/germany/eisenach/",
          "label": "アイゼナッハ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/augsburg/",
          "label": "アウクスブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/aachen/",
          "label": "アーヘン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/emden/",
          "label": "エムデン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/kassel/",
          "label": "カッセル",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/cologne/",
          "label": "ケルン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/kempten-allgaeu/",
          "label": "ケンプテン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/stuttgart/",
          "label": "シュトゥットガルト",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/schleswig/",
          "label": "シュレースビヒ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/dusseldorf/",
          "label": "デュッセルドルフ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/dresden/",
          "label": "ドレスデン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/nuremberg/",
          "label": "ニュルンベルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/nordlingen/",
          "label": "ネルトリンゲン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/heidelberg/",
          "label": "ハイデルベルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/hannover/",
          "label": "ハノーファー",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/hamburg/",
          "label": "ハンブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/fussen/",
          "label": "フュッセン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/frankfurt-am-main/",
          "label": "フランクフルト",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/bremen/",
          "label": "ブレーメン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/berlin/",
          "label": "ベルリン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/bonn/",
          "label": "ボン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/meissen/",
          "label": "マイセン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/munich/",
          "label": "ミュンヘン",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/leipzig/",
          "label": "ライプツィヒ",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/rudesheim/",
          "label": "リューデスハイム",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/rothenburg/",
          "label": "ローテンブルク",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/weimar/",
          "label": "ワイマール",
          "country_ja": "ドイツ"
        },
        {
          "point_id": "/5/germany/wurzburg/",
          "label": "ヴュルツブルク",
          "country_ja": "ドイツ"
        }
      ],
      "norway": [
        {
          "point_id": "/5/norway/alta/",
          "label": "アルタ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/oslo/",
          "label": "オスロ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/kirkenes/",
          "label": "キルケネス",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/geiranger/",
          "label": "ゲイランゲル",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/stavanger/",
          "label": "スタバンゲル",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/tromso/",
          "label": "トロムソ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/trondheim/",
          "label": "トロンヘイム",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/fagernes/",
          "label": "ファーゲルネス",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/flam/",
          "label": "フロム",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/bergen/",
          "label": "ベルゲン",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/honningsvag/",
          "label": "ホニングスヴォーグ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/bodo/",
          "label": "ボーデ",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/myrdal/",
          "label": "ミュールダール",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/longyearbyen/",
          "label": "ロングイェールビーン（スバールバル諸島）",
          "country_ja": "ノルウェー"
        },
        {
          "point_id": "/5/norway/vossevangen/",
          "label": "ヴォス",
          "country_ja": "ノルウェー"
        }
      ],
      "belarus": [
        {
          "point_id": "/5/belarus/brest/",
          "label": "ブレスト",
          "country_ja": "ベラルーシ"
        },
        {
          "point_id": "/5/belarus/gomel/",
          "label": "ホメリ",
          "country_ja": "ベラルーシ"
        },
        {
          "point_id": "/5/belarus/minsk/",
          "label": "ミンスク",
          "country_ja": "ベラルーシ"
        }
      ],
      "belgium": [
        {
          "point_id": "/5/belgium/antwerpen/",
          "label": "アントウェルペン",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/ghent/",
          "label": "ゲント",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/dinant/",
          "label": "ディナン",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/durbuy/",
          "label": "デュルビュイ",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/namur/",
          "label": "ナミュール",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/hasselt/",
          "label": "ハッセルト",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/brussels/",
          "label": "ブリュッセル",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/bruges/",
          "label": "ブルージュ",
          "country_ja": "ベルギー"
        },
        {
          "point_id": "/5/belgium/mechelen/",
          "label": "メッヘレン",
          "country_ja": "ベルギー"
        }
      ],
      "bosnia-and-herzegovina": [
        {
          "point_id": "/5/bosnia-and-herzegovina/sarajevo/",
          "label": "サラエボ",
          "country_ja": "ボスニア・ヘルツェゴビナ"
        }
      ],
      "portugal": [
        {
          "point_id": "/5/portugal/aveiro/",
          "label": "アヴェイロ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/evora/",
          "label": "エボラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/obidos/",
          "label": "オビドス",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/guimaraes/",
          "label": "ギマラインス",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/coimbra/",
          "label": "コインブラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/sintra/",
          "label": "シントラ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/nazare/",
          "label": "ナザレ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/batalha/",
          "label": "バターリャ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/fatima/",
          "label": "ファティマ",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/funchal/",
          "label": "フンシャル（マデイラ諸島）",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/porto/",
          "label": "ポルト",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/lisbon/",
          "label": "リスボン",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/santa-maria/",
          "label": "ヴィーラ・ド・ポルト（サンタマリア島）",
          "country_ja": "ポルトガル"
        },
        {
          "point_id": "/5/portugal/porto-santo/",
          "label": "ヴィーラ・バレイラ（ポルトサント島）",
          "country_ja": "ポルトガル"
        }
      ],
      "poland": [
        {
          "point_id": "/5/poland/lodz/",
          "label": "ウッチ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/katowice/",
          "label": "カトビーツェ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/krakow/",
          "label": "クラクフ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/gdansk/",
          "label": "グダニスク",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/zamosc/",
          "label": "ザモシチ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/czestochowa/",
          "label": "チェストホバ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/torun/",
          "label": "トルニ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/wroclaw/",
          "label": "ブロツワフ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/poznan/",
          "label": "ポズナニ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/warsaw/",
          "label": "ワルシャワ",
          "country_ja": "ポーランド"
        },
        {
          "point_id": "/5/poland/wieliczka/",
          "label": "ヴィエリチカ",
          "country_ja": "ポーランド"
        }
      ],
      "malta": [
        {
          "point_id": "/5/malta/mdina/",
          "label": "イムディーナ",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/malta/saint-julian/",
          "label": "サンジュリアン",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/malta/valletta/",
          "label": "バレッタ（マルタ島）",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/malta/victoria/",
          "label": "ビクトリア（ゴゾ島）",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/malta/marsaxlokk/",
          "label": "マルサックスロック",
          "country_ja": "マルタ"
        },
        {
          "point_id": "/5/malta/rabat/",
          "label": "ラバト",
          "country_ja": "マルタ"
        }
      ],
      "moldova": [
        {
          "point_id": "/5/moldova/chisinau/",
          "label": "キシナウ",
          "country_ja": "モルドバ"
        }
      ],
      "montenegro": [
        {
          "point_id": "/5/montenegro/pljevlja/",
          "label": "プリエプリャ",
          "country_ja": "モンテネグロ"
        },
        {
          "point_id": "/5/montenegro/podgorica/",
          "label": "ポドゴリツァ",
          "country_ja": "モンテネグロ"
        }
      ],
      "latvia": [
        {
          "point_id": "/5/latvia/daugavpils/",
          "label": "ダウガフピールス",
          "country_ja": "ラトビア"
        },
        {
          "point_id": "/5/latvia/liepaja/",
          "label": "リエパヤ",
          "country_ja": "ラトビア"
        },
        {
          "point_id": "/5/latvia/riga/",
          "label": "リガ",
          "country_ja": "ラトビア"
        }
      ],
      "hungary": [
        {
          "point_id": "/5/hungary/eger/",
          "label": "エゲル",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/sopron/",
          "label": "ショプロン",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/gyor/",
          "label": "ジェール",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/dunaujvaros/",
          "label": "ドゥナウーイバーロシュ",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/nagykanizsa/",
          "label": "ナジカニジャ",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/budapest/",
          "label": "ブダペスト",
          "country_ja": "ハンガリー"
        },
        {
          "point_id": "/5/hungary/pecs/",
          "label": "ペーチ",
          "country_ja": "ハンガリー"
        }
      ],
      "finland": [
        {
          "point_id": "/5/finland/ivalo/",
          "label": "イヴァロ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/kemi/",
          "label": "ケミ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/saariselka/",
          "label": "サーリセルカ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/sodankyla/",
          "label": "ソダンキュラ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/tampere/",
          "label": "タンペレ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/turku/",
          "label": "トゥルク",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/naantali/",
          "label": "ナーンタリ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/helsinki/",
          "label": "ヘルシンキ",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/porvoo/",
          "label": "ポルヴォー",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/jokioinen/",
          "label": "ヨキオイネン",
          "country_ja": "フィンランド"
        },
        {
          "point_id": "/5/finland/rovaniemi/",
          "label": "ロバニエミ",
          "country_ja": "フィンランド"
        }
      ],
      "france": [
        {
          "point_id": "/5/france/ajaccio/",
          "label": "アジャクシオ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/arles/",
          "label": "アルル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/avignon/",
          "label": "アヴィニヨン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/evian-les-bains/",
          "label": "エビアン・レ・バン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/honfleur/",
          "label": "オンフルール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/carcassonne/",
          "label": "カルカッソンヌ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/cannes/",
          "label": "カンヌ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/caen/",
          "label": "カーン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/colmar/",
          "label": "コルマール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/saint-denis/",
          "label": "サンドニ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/chamonix/",
          "label": "シャモニー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/chartres/",
          "label": "シャルトル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/giverny/",
          "label": "ジヴェルニー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/strasbourg/",
          "label": "ストラスブール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/dijon/",
          "label": "ディジョン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/tours/",
          "label": "トゥール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/toulouse/",
          "label": "トゥールーズ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/nancy/",
          "label": "ナンシー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/nantes/",
          "label": "ナント",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/nice/",
          "label": "ニース",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/paris/",
          "label": "パリ（Paris）",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/brest/",
          "label": "ブレスト",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/bourges/",
          "label": "ブールジュ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/perpignan/",
          "label": "ペルピニャン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/bordeaux/",
          "label": "ボルドー",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/marseille/",
          "label": "マルセイユ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/montpellier/",
          "label": "モンペリエ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/reims/",
          "label": "ランス",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/limoges/",
          "label": "リモージュ",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/lyon/",
          "label": "リヨン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/lille/",
          "label": "リール",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/lourdes/",
          "label": "ルルド",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/le-havre/",
          "label": "ル・アーヴル",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/rouen/",
          "label": "ルーアン",
          "country_ja": "フランス"
        },
        {
          "point_id": "/5/france/rennes/",
          "label": "レンヌ",
          "country_ja": "フランス"
        }
      ],
      "bulgaria": [
        {
          "point_id": "/5/bulgaria/kazanlak/",
          "label": "カザンルク",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/sliven/",
          "label": "スリベン",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/sofia/",
          "label": "ソフィア",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/varna/",
          "label": "バルナ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/plovdiv/",
          "label": "プロブディフ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/veliko-tarnovo/",
          "label": "ベリコタルノボ",
          "country_ja": "ブルガリア"
        },
        {
          "point_id": "/5/bulgaria/ruse/",
          "label": "ルセ",
          "country_ja": "ブルガリア"
        }
      ],
      "lithuania": [
        {
          "point_id": "/5/lithuania/kaunas/",
          "label": "カウナス",
          "country_ja": "リトアニア"
        },
        {
          "point_id": "/5/lithuania/klaipeda/",
          "label": "クライペダ",
          "country_ja": "リトアニア"
        },
        {
          "point_id": "/5/lithuania/vilnius/",
          "label": "ビリニュス",
          "country_ja": "リトアニア"
        }
      ],
      "liechtenstein": [
        {
          "point_id": "/5/liechtenstein/vaduz/",
          "label": "ファドゥーツ",
          "country_ja": "リヒテンシュタイン"
        }
      ],
      "luxembourg": [
        {
          "point_id": "/5/luxembourg/luxembourg/",
          "label": "ルクセンブルク",
          "country_ja": "ルクセンブルク"
        }
      ],
      "romania": [
        {
          "point_id": "/5/romania/arad/",
          "label": "アラド",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/constanta/",
          "label": "コンスタンツァ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/sighisoara/",
          "label": "シギショアラ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/sinaia/",
          "label": "シナイア",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/sibiu/",
          "label": "シビウ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/bucharest/",
          "label": "ブカレスト",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/buzau/",
          "label": "ブザウ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/brasov/",
          "label": "ブラショフ",
          "country_ja": "ルーマニア"
        },
        {
          "point_id": "/5/romania/iasi/",
          "label": "ヤーシ",
          "country_ja": "ルーマニア"
        }
      ],
      "russia": [
        {
          "point_id": "/5/russia/vladivostok/",
          "label": "ウラジオストク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/yekaterinburg/",
          "label": "エカテリンブルグ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/oymyakon/",
          "label": "オイミヤコン",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/omsk/",
          "label": "オムスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/kazan/",
          "label": "カザン",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/kaliningrad/",
          "label": "カリーニングラード",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/krasnodar/",
          "label": "クラスノダール",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/samara/",
          "label": "サマーラ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/saint-petersburg/",
          "label": "サンクトペテルブルク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/sochi/",
          "label": "ソチ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/chelyabinsk/",
          "label": "チェリャビンスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/tula/",
          "label": "トゥーラ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/nizhniy-novgorod/",
          "label": "ニージニー・ノブゴロド",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/novosibirsk/",
          "label": "ノボシビールスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/khabarovsk/",
          "label": "ハバロフスク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/volgograd/",
          "label": "ボルゴグラード",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/voronezh/",
          "label": "ボロネシ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/moscow/",
          "label": "モスクワ",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/yakutsk/",
          "label": "ヤクーツク",
          "country_ja": "ロシア"
        },
        {
          "point_id": "/5/russia/rostov/",
          "label": "ロストフ・ナ・ドヌー",
          "country_ja": "ロシア"
        }
      ],
      "kosovo": [
        {
          "point_id": "/5/kosovo/pristina/",
          "label": "プリシュティナ",
          "country_ja": "コソボ"
        }
      ],
      "san-marino": [
        {
          "point_id": "/5/san-marino/san-marino/",
          "label": "サンマリノ",
          "country_ja": "サンマリノ共和国"
        }
      ],
      "slovenia": [
        {
          "point_id": "/5/slovenia/maribor/",
          "label": "マリボル",
          "country_ja": "スロベニア共和国"
        },
        {
          "point_id": "/5/slovenia/ljubljana/",
          "label": "リュブリャナ",
          "country_ja": "スロベニア共和国"
        }
      ],
      "vatican-city": [
        {
          "point_id": "/5/vatican-city/vatican-city/",
          "label": "バチカン市国",
          "country_ja": "バチカン市国"
        }
      ],
      "monaco": [
        {
          "point_id": "/5/monaco/monaco/",
          "label": "モナコ",
          "country_ja": "モナコ公国"
        }
      ],
      "azerbaijan": [
        {
          "point_id": "/5/azerbaijan/baku/",
          "label": "バクー",
          "country_ja": "アゼルバイジャン"
        }
      ],
      "georgia": [
        {
          "point_id": "/5/georgia/tbilisi/",
          "label": "トビリシ",
          "country_ja": "ジョージア"
        }
      ],
      "armenia": [
        {
          "point_id": "/5/armenia/yerevan/",
          "label": "エレバン",
          "country_ja": "アルメニア"
        }
      ]
    }
  },
  "6": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "american-samoa",
        "label": "アメリカ領サモア"
      },
      {
        "country_id": "australia",
        "label": "オーストラリア"
      },
      {
        "country_id": "kiribati",
        "label": "キリバス"
      },
      {
        "country_id": "cook-islands",
        "label": "クック諸島"
      },
      {
        "country_id": "guam",
        "label": "グアム"
      },
      {
        "country_id": "saipan",
        "label": "サイパン"
      },
      {
        "country_id": "independent-state-of-samoa",
        "label": "サモア独立国"
      },
      {
        "country_id": "solomon-islands",
        "label": "ソロモン諸島"
      },
      {
        "country_id": "tahiti",
        "label": "タヒチ"
      },
      {
        "country_id": "tuvalu",
        "label": "ツバル"
      },
      {
        "country_id": "tonga",
        "label": "トンガ"
      },
      {
        "country_id": "nauru",
        "label": "ナウル共和国"
      },
      {
        "country_id": "niue",
        "label": "ニウエ"
      },
      {
        "country_id": "new-caledonia",
        "label": "ニューカレドニア"
      },
      {
        "country_id": "new-zealand",
        "label": "ニュージーランド"
      },
      {
        "country_id": "hawaii",
        "label": "ハワイ"
      },
      {
        "country_id": "vanuatu",
        "label": "バヌアツ"
      },
      {
        "country_id": "papua-new-guinea",
        "label": "パプアニューギニア"
      },
      {
        "country_id": "palau",
        "label": "パラオ"
      },
      {
        "country_id": "fiji",
        "label": "フィジー"
      },
      {
        "country_id": "marshall-islands",
        "label": "マーシャル諸島"
      },
      {
        "country_id": "micronesia",
        "label": "ミクロネシア連邦"
      },
      {
        "country_id": "wallis-and-futuna",
        "label": "ワリス・フテュナ"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/6/australia/adelaide/",
          "label": "アデレード",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/cook-islands/avarua/",
          "label": "アバルア（ラロトンガ島）",
          "country_ja": "クック諸島"
        },
        {
          "point_id": "/6/independent-state-of-samoa/apia/",
          "label": "アピア",
          "country_ja": "サモア独立国"
        },
        {
          "point_id": "/6/australia/alice-springs/",
          "label": "アリススプリングス",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/niue/alofi/",
          "label": "アロフィ",
          "country_ja": "ニウエ"
        },
        {
          "point_id": "/6/new-zealand/oamaru/",
          "label": "アロータウン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/wellington/",
          "label": "ウェリントン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/wollongong/",
          "label": "ウロンゴン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/arrowtown/",
          "label": "オアマル",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/albany/",
          "label": "オルバニー",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/auckland/",
          "label": "オークランド",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/hawaii/kihei/",
          "label": "キヘイ（マウイ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/australia/canberra/",
          "label": "キャンベラ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/queenstown/",
          "label": "クイーンズタウン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/christchurch/",
          "label": "クライストチャーチ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/green-island/",
          "label": "グリーン島",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/cairns/",
          "label": "ケアンズ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/palau/koror/",
          "label": "コロール",
          "country_ja": "パラオ"
        },
        {
          "point_id": "/6/australia/gold-coast/",
          "label": "ゴールドコースト",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/saipan/saipan/",
          "label": "サイパン島",
          "country_ja": "サイパン"
        },
        {
          "point_id": "/6/fiji/savusavu/",
          "label": "サブサブ ",
          "country_ja": "フィジー"
        },
        {
          "point_id": "/6/australia/sunshine-coast/",
          "label": "サンシャインコースト",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/sydney/",
          "label": "シドニー",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/fiji/suva/",
          "label": "スバ",
          "country_ja": "フィジー"
        },
        {
          "point_id": "/6/new-zealand/taupo/",
          "label": "タウポ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/guam/guam/",
          "label": "タモン（グアム島）",
          "country_ja": "グアム"
        },
        {
          "point_id": "/6/new-zealand/dunedin/",
          "label": "ダニーディン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/darwin/",
          "label": "ダーウィン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/te-anau/",
          "label": "テアナウ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/devonport/",
          "label": "デボンポート（タスマニア島）",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/fiji/nadi/",
          "label": "ナンディ",
          "country_ja": "フィジー"
        },
        {
          "point_id": "/6/australia/newcastle/",
          "label": "ニューカッスル",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/tonga/nukualofa/",
          "label": "ヌクアロファ（トンガタプ諸島）",
          "country_ja": "トンガ"
        },
        {
          "point_id": "/6/micronesia/nukuoro/",
          "label": "ヌクオロ島",
          "country_ja": "ミクロネシア連邦"
        },
        {
          "point_id": "/6/new-caledonia/noumea/",
          "label": "ヌメア",
          "country_ja": "ニューカレドニア"
        },
        {
          "point_id": "/6/new-zealand/nelson/",
          "label": "ネルソン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/kiribati/tarawa/",
          "label": "バイリキ（タラワ島）",
          "country_ja": "キリバス"
        },
        {
          "point_id": "/6/american-samoa/pago-pago/",
          "label": "パゴパゴ",
          "country_ja": "アメリカ領サモア"
        },
        {
          "point_id": "/6/tahiti/papeete/",
          "label": "パペーテ（タヒチ島）",
          "country_ja": "タヒチ"
        },
        {
          "point_id": "/6/micronesia/palikir/",
          "label": "パリキール",
          "country_ja": "ミクロネシア連邦"
        },
        {
          "point_id": "/6/australia/perth/",
          "label": "パース",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/palmerston-north/",
          "label": "パーマストンノース",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/hawaii/hilo/",
          "label": "ヒロ（ハワイ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/wallis-and-futuna/mata-utu/",
          "label": "フテュナ島",
          "country_ja": "ワリス・フテュナ"
        },
        {
          "point_id": "/6/tuvalu/funafuti/",
          "label": "フナフティ",
          "country_ja": "ツバル"
        },
        {
          "point_id": "/6/australia/fremantle/",
          "label": "フリーマントル",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/brisbane/",
          "label": "ブリスベン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/solomon-islands/honiara/",
          "label": "ホニアラ",
          "country_ja": "ソロモン諸島"
        },
        {
          "point_id": "/6/hawaii/honolulu/",
          "label": "ホノルル（オアフ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/australia/hobart/",
          "label": "ホバート（タスマニア島）",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/bowen/",
          "label": "ボウエン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/vanuatu/port-vila/",
          "label": "ポートビラ（エファテ島）",
          "country_ja": "バヌアツ"
        },
        {
          "point_id": "/6/papua-new-guinea/port-moresby/",
          "label": "ポートモレスビー",
          "country_ja": "パプアニューギニア"
        },
        {
          "point_id": "/6/marshall-islands/majuro/",
          "label": "マジュロ",
          "country_ja": "マーシャル諸島"
        },
        {
          "point_id": "/6/papua-new-guinea/madang/",
          "label": "マダン",
          "country_ja": "パプアニューギニア"
        },
        {
          "point_id": "/6/australia/melbourne/",
          "label": "メルボルン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/nauru/yaren/",
          "label": "ヤレン地区",
          "country_ja": "ナウル共和国"
        },
        {
          "point_id": "/6/australia/eulala/",
          "label": "ユーラーラ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/hawaii/lihue/",
          "label": "リフエ（カウアイ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/australia/rottnest-island/",
          "label": "ロットネスト島",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/rotorua/",
          "label": "ロトルア",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/australia/launceston/",
          "label": "ローンセストン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/new-zealand/wanaka/",
          "label": "ワナカ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/palau/ngerulmud/",
          "label": "ンゲルルムッド",
          "country_ja": "パラオ"
        }
      ],
      "hawaii": [
        {
          "point_id": "/6/hawaii/kihei/",
          "label": "キヘイ（マウイ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/hawaii/hilo/",
          "label": "ヒロ（ハワイ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/hawaii/honolulu/",
          "label": "ホノルル（オアフ島）",
          "country_ja": "ハワイ"
        },
        {
          "point_id": "/6/hawaii/lihue/",
          "label": "リフエ（カウアイ島）",
          "country_ja": "ハワイ"
        }
      ],
      "australia": [
        {
          "point_id": "/6/australia/adelaide/",
          "label": "アデレード",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/alice-springs/",
          "label": "アリススプリングス",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/wollongong/",
          "label": "ウロンゴン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/albany/",
          "label": "オルバニー",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/canberra/",
          "label": "キャンベラ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/green-island/",
          "label": "グリーン島",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/cairns/",
          "label": "ケアンズ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/gold-coast/",
          "label": "ゴールドコースト",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/sunshine-coast/",
          "label": "サンシャインコースト",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/sydney/",
          "label": "シドニー",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/darwin/",
          "label": "ダーウィン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/devonport/",
          "label": "デボンポート（タスマニア島）",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/newcastle/",
          "label": "ニューカッスル",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/perth/",
          "label": "パース",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/fremantle/",
          "label": "フリーマントル",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/brisbane/",
          "label": "ブリスベン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/hobart/",
          "label": "ホバート（タスマニア島）",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/bowen/",
          "label": "ボウエン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/melbourne/",
          "label": "メルボルン",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/eulala/",
          "label": "ユーラーラ",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/rottnest-island/",
          "label": "ロットネスト島",
          "country_ja": "オーストラリア"
        },
        {
          "point_id": "/6/australia/launceston/",
          "label": "ローンセストン",
          "country_ja": "オーストラリア"
        }
      ],
      "new-zealand": [
        {
          "point_id": "/6/new-zealand/oamaru/",
          "label": "アロータウン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/wellington/",
          "label": "ウェリントン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/arrowtown/",
          "label": "オアマル",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/auckland/",
          "label": "オークランド",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/queenstown/",
          "label": "クイーンズタウン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/christchurch/",
          "label": "クライストチャーチ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/taupo/",
          "label": "タウポ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/dunedin/",
          "label": "ダニーディン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/te-anau/",
          "label": "テアナウ",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/nelson/",
          "label": "ネルソン",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/palmerston-north/",
          "label": "パーマストンノース",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/rotorua/",
          "label": "ロトルア",
          "country_ja": "ニュージーランド"
        },
        {
          "point_id": "/6/new-zealand/wanaka/",
          "label": "ワナカ",
          "country_ja": "ニュージーランド"
        }
      ],
      "guam": [
        {
          "point_id": "/6/guam/guam/",
          "label": "タモン（グアム島）",
          "country_ja": "グアム"
        }
      ],
      "saipan": [
        {
          "point_id": "/6/saipan/saipan/",
          "label": "サイパン島",
          "country_ja": "サイパン"
        }
      ],
      "tahiti": [
        {
          "point_id": "/6/tahiti/papeete/",
          "label": "パペーテ（タヒチ島）",
          "country_ja": "タヒチ"
        }
      ],
      "american-samoa": [
        {
          "point_id": "/6/american-samoa/pago-pago/",
          "label": "パゴパゴ",
          "country_ja": "アメリカ領サモア"
        }
      ],
      "kiribati": [
        {
          "point_id": "/6/kiribati/tarawa/",
          "label": "バイリキ（タラワ島）",
          "country_ja": "キリバス"
        }
      ],
      "cook-islands": [
        {
          "point_id": "/6/cook-islands/avarua/",
          "label": "アバルア（ラロトンガ島）",
          "country_ja": "クック諸島"
        }
      ],
      "independent-state-of-samoa": [
        {
          "point_id": "/6/independent-state-of-samoa/apia/",
          "label": "アピア",
          "country_ja": "サモア独立国"
        }
      ],
      "solomon-islands": [
        {
          "point_id": "/6/solomon-islands/honiara/",
          "label": "ホニアラ",
          "country_ja": "ソロモン諸島"
        }
      ],
      "tuvalu": [
        {
          "point_id": "/6/tuvalu/funafuti/",
          "label": "フナフティ",
          "country_ja": "ツバル"
        }
      ],
      "tonga": [
        {
          "point_id": "/6/tonga/nukualofa/",
          "label": "ヌクアロファ（トンガタプ諸島）",
          "country_ja": "トンガ"
        }
      ],
      "new-caledonia": [
        {
          "point_id": "/6/new-caledonia/noumea/",
          "label": "ヌメア",
          "country_ja": "ニューカレドニア"
        }
      ],
      "vanuatu": [
        {
          "point_id": "/6/vanuatu/port-vila/",
          "label": "ポートビラ（エファテ島）",
          "country_ja": "バヌアツ"
        }
      ],
      "papua-new-guinea": [
        {
          "point_id": "/6/papua-new-guinea/port-moresby/",
          "label": "ポートモレスビー",
          "country_ja": "パプアニューギニア"
        },
        {
          "point_id": "/6/papua-new-guinea/madang/",
          "label": "マダン",
          "country_ja": "パプアニューギニア"
        }
      ],
      "palau": [
        {
          "point_id": "/6/palau/koror/",
          "label": "コロール",
          "country_ja": "パラオ"
        },
        {
          "point_id": "/6/palau/ngerulmud/",
          "label": "ンゲルルムッド",
          "country_ja": "パラオ"
        }
      ],
      "fiji": [
        {
          "point_id": "/6/fiji/savusavu/",
          "label": "サブサブ ",
          "country_ja": "フィジー"
        },
        {
          "point_id": "/6/fiji/suva/",
          "label": "スバ",
          "country_ja": "フィジー"
        },
        {
          "point_id": "/6/fiji/nadi/",
          "label": "ナンディ",
          "country_ja": "フィジー"
        }
      ],
      "marshall-islands": [
        {
          "point_id": "/6/marshall-islands/majuro/",
          "label": "マジュロ",
          "country_ja": "マーシャル諸島"
        }
      ],
      "micronesia": [
        {
          "point_id": "/6/micronesia/nukuoro/",
          "label": "ヌクオロ島",
          "country_ja": "ミクロネシア連邦"
        },
        {
          "point_id": "/6/micronesia/palikir/",
          "label": "パリキール",
          "country_ja": "ミクロネシア連邦"
        }
      ],
      "wallis-and-futuna": [
        {
          "point_id": "/6/wallis-and-futuna/mata-utu/",
          "label": "フテュナ島",
          "country_ja": "ワリス・フテュナ"
        }
      ],
      "nauru": [
        {
          "point_id": "/6/nauru/yaren/",
          "label": "ヤレン地区",
          "country_ja": "ナウル共和国"
        }
      ],
      "niue": [
        {
          "point_id": "/6/niue/alofi/",
          "label": "アロフィ",
          "country_ja": "ニウエ"
        }
      ]
    }
  },
  "7": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "us",
        "label": "アメリカ"
      },
      {
        "country_id": "alaska",
        "label": "アラスカ"
      },
      {
        "country_id": "canada",
        "label": "カナダ"
      },
      {
        "country_id": "bermuda",
        "label": "バーミューダ諸島"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/7/us/atlanta/",
          "label": "アトランタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/anaheim/",
          "label": "アナハイム",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/aberdeen-south-dakota/",
          "label": "アバディーン（サウスダコタ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/albuquerque/",
          "label": "アルバカーキ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/alaska/anchorage/",
          "label": "アンカレジ",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/canada/yellowknife/",
          "label": "イエローナイフ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/iqaluit/",
          "label": "イカルイト",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/indianapolis/",
          "label": "インディアナポリス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/whistler/",
          "label": "ウィスラー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/winnipeg/",
          "label": "ウィニペグ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/west-kelowna/",
          "label": "ウェストケローナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/edmonton/",
          "label": "エドモントン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/el-paso/",
          "label": "エルパソ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/oklahoma-city/",
          "label": "オクラホマシティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/ottawa/",
          "label": "オタワ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/omaha/",
          "label": "オマハ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/augusta/",
          "label": "オーガスタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/orlando/",
          "label": "オーランド",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/kayenta/",
          "label": "カイエンタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/kamloops/",
          "label": "カムループス",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/calgary/",
          "label": "カルガリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/kansas-city/",
          "label": "カンザスシティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/cleveland/",
          "label": "クリーヴランド（オハイオ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/tn-cleveland/",
          "label": "クリーヴランド（テネシー州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/quebec/",
          "label": "ケベックシティー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/kelowna/",
          "label": "ケローナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/sacramento/",
          "label": "サクラメント",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/saskatoon/",
          "label": "サスカトゥーン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/sudbury/",
          "label": "サドベリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/san-antonio/",
          "label": "サンアントニオ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/thunder-bay/",
          "label": "サンダーベイ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/san-diego/",
          "label": "サンディエゴ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/san-francisco/",
          "label": "サンフランシスコ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/seattle/",
          "label": "シアトル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/chicago/",
          "label": "シカゴ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/charlottetown/",
          "label": "シャーロットタウン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/cincinnati/",
          "label": "シンシナティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/jacksonville/",
          "label": "ジャクソンビル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/jasper/",
          "label": "ジャスパー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/alaska/juneau/",
          "label": "ジュノー",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/us/springfield/",
          "label": "スプリングフィールド（イリノイ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/sedona/",
          "label": "セドナ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/st-louis/",
          "label": "セントルイス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/st-johns/",
          "label": "セント・ジョンズ（ニューファンドランド・ラブラドール州）",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/saint-john/",
          "label": "セント・ジョン（ニューブランズウィック州）",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/salt-lake-city/",
          "label": "ソルト・レーク・シティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/dallas/",
          "label": "ダラス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/charleston/",
          "label": "チャールストン（ウエストバージニア州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/sc-charleston/",
          "label": "チャールストン（サウス・カロライナ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/detroit/",
          "label": "デトロイト",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/denver/",
          "label": "デンバー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/toronto/",
          "label": "トロント",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/niagara-on-the-lake/",
          "label": "ナイアガラオンザレイク",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/nashville/",
          "label": "ナッシュビル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/new-orleans/",
          "label": "ニューオーリンズ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/new-york/",
          "label": "ニューヨーク（New York）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/norman/",
          "label": "ノーマン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/alaska/nome/",
          "label": "ノーム",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/bermuda/hamilton/",
          "label": "ハミルトン",
          "country_ja": "バーミューダ諸島"
        },
        {
          "point_id": "/7/canada/halifax/",
          "label": "ハリファックス",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/buffalo/",
          "label": "バッファロー（ニューヨーク州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/alaska/barrow/",
          "label": "バロー",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/canada/vancouver/",
          "label": "バンクーバー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/banff/",
          "label": "バンフ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/vernon/",
          "label": "バーノン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/houston/",
          "label": "ヒューストン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/victoria/",
          "label": "ビクトリア",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/bismarck/",
          "label": "ビスマーク",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/pittsburgh/",
          "label": "ピッツバーグ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/philadelphia/",
          "label": "フィラデルフィア",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/alaska/fairbanks/",
          "label": "フェアバンクス",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/us/phoenix/",
          "label": "フェニックス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/providence/",
          "label": "プロビデンス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/paige/",
          "label": "ペイジ（アリゾナ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/whitehorse/",
          "label": "ホワイトホース",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/boston/",
          "label": "ボストン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/portland/",
          "label": "ポートランド（オレゴン州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/miami/",
          "label": "マイアミ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/minneapolis/",
          "label": "ミネアポリス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/milwaukee/",
          "label": "ミルウォーキー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/memphis/",
          "label": "メンフィス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/montgomery/",
          "label": "モンゴメリー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/montreal/",
          "label": "モントリオール",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/las-vegas/",
          "label": "ラスベガス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/regina/",
          "label": "リジャイナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/richmond/",
          "label": "リッチモンド（バージニア州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/lincoln/",
          "label": "リンカーン（ネブラスカ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/lake-country/",
          "label": "レイクカントリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/los-angeles/",
          "label": "ロサンゼルス（LA）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/canada/london/",
          "label": "ロンドン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/us/washington-dc/",
          "label": "ワシントンD.C.",
          "country_ja": "アメリカ"
        }
      ],
      "us": [
        {
          "point_id": "/7/us/atlanta/",
          "label": "アトランタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/anaheim/",
          "label": "アナハイム",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/aberdeen-south-dakota/",
          "label": "アバディーン（サウスダコタ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/albuquerque/",
          "label": "アルバカーキ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/indianapolis/",
          "label": "インディアナポリス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/el-paso/",
          "label": "エルパソ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/oklahoma-city/",
          "label": "オクラホマシティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/omaha/",
          "label": "オマハ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/augusta/",
          "label": "オーガスタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/orlando/",
          "label": "オーランド",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/kayenta/",
          "label": "カイエンタ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/kansas-city/",
          "label": "カンザスシティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/cleveland/",
          "label": "クリーヴランド（オハイオ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/tn-cleveland/",
          "label": "クリーヴランド（テネシー州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/sacramento/",
          "label": "サクラメント",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/san-antonio/",
          "label": "サンアントニオ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/san-diego/",
          "label": "サンディエゴ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/san-francisco/",
          "label": "サンフランシスコ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/seattle/",
          "label": "シアトル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/chicago/",
          "label": "シカゴ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/cincinnati/",
          "label": "シンシナティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/jacksonville/",
          "label": "ジャクソンビル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/springfield/",
          "label": "スプリングフィールド（イリノイ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/sedona/",
          "label": "セドナ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/st-louis/",
          "label": "セントルイス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/salt-lake-city/",
          "label": "ソルト・レーク・シティ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/dallas/",
          "label": "ダラス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/charleston/",
          "label": "チャールストン（ウエストバージニア州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/sc-charleston/",
          "label": "チャールストン（サウス・カロライナ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/detroit/",
          "label": "デトロイト",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/denver/",
          "label": "デンバー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/nashville/",
          "label": "ナッシュビル",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/new-orleans/",
          "label": "ニューオーリンズ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/new-york/",
          "label": "ニューヨーク（New York）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/norman/",
          "label": "ノーマン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/buffalo/",
          "label": "バッファロー（ニューヨーク州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/houston/",
          "label": "ヒューストン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/bismarck/",
          "label": "ビスマーク",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/pittsburgh/",
          "label": "ピッツバーグ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/philadelphia/",
          "label": "フィラデルフィア",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/phoenix/",
          "label": "フェニックス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/providence/",
          "label": "プロビデンス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/paige/",
          "label": "ペイジ（アリゾナ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/boston/",
          "label": "ボストン",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/portland/",
          "label": "ポートランド（オレゴン州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/miami/",
          "label": "マイアミ",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/minneapolis/",
          "label": "ミネアポリス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/milwaukee/",
          "label": "ミルウォーキー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/memphis/",
          "label": "メンフィス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/montgomery/",
          "label": "モンゴメリー",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/las-vegas/",
          "label": "ラスベガス",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/richmond/",
          "label": "リッチモンド（バージニア州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/lincoln/",
          "label": "リンカーン（ネブラスカ州）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/los-angeles/",
          "label": "ロサンゼルス（LA）",
          "country_ja": "アメリカ"
        },
        {
          "point_id": "/7/us/washington-dc/",
          "label": "ワシントンD.C.",
          "country_ja": "アメリカ"
        }
      ],
      "alaska": [
        {
          "point_id": "/7/alaska/anchorage/",
          "label": "アンカレジ",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/alaska/juneau/",
          "label": "ジュノー",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/alaska/nome/",
          "label": "ノーム",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/alaska/barrow/",
          "label": "バロー",
          "country_ja": "アラスカ"
        },
        {
          "point_id": "/7/alaska/fairbanks/",
          "label": "フェアバンクス",
          "country_ja": "アラスカ"
        }
      ],
      "canada": [
        {
          "point_id": "/7/canada/yellowknife/",
          "label": "イエローナイフ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/iqaluit/",
          "label": "イカルイト",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/whistler/",
          "label": "ウィスラー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/winnipeg/",
          "label": "ウィニペグ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/west-kelowna/",
          "label": "ウェストケローナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/edmonton/",
          "label": "エドモントン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/ottawa/",
          "label": "オタワ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/kamloops/",
          "label": "カムループス",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/calgary/",
          "label": "カルガリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/quebec/",
          "label": "ケベックシティー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/kelowna/",
          "label": "ケローナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/saskatoon/",
          "label": "サスカトゥーン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/sudbury/",
          "label": "サドベリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/thunder-bay/",
          "label": "サンダーベイ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/charlottetown/",
          "label": "シャーロットタウン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/jasper/",
          "label": "ジャスパー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/st-johns/",
          "label": "セント・ジョンズ（ニューファンドランド・ラブラドール州）",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/saint-john/",
          "label": "セント・ジョン（ニューブランズウィック州）",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/toronto/",
          "label": "トロント",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/niagara-on-the-lake/",
          "label": "ナイアガラオンザレイク",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/halifax/",
          "label": "ハリファックス",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/vancouver/",
          "label": "バンクーバー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/banff/",
          "label": "バンフ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/vernon/",
          "label": "バーノン",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/victoria/",
          "label": "ビクトリア",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/whitehorse/",
          "label": "ホワイトホース",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/montreal/",
          "label": "モントリオール",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/regina/",
          "label": "リジャイナ",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/lake-country/",
          "label": "レイクカントリー",
          "country_ja": "カナダ"
        },
        {
          "point_id": "/7/canada/london/",
          "label": "ロンドン",
          "country_ja": "カナダ"
        }
      ],
      "bermuda": [
        {
          "point_id": "/7/bermuda/hamilton/",
          "label": "ハミルトン",
          "country_ja": "バーミューダ諸島"
        }
      ]
    }
  },
  "8": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "us-virgin-islands",
        "label": "アメリカ領バージン諸島"
      },
      {
        "country_id": "argentina",
        "label": "アルゼンチン"
      },
      {
        "country_id": "antigua-and-barbuda",
        "label": "アンティグア・バーブーダ"
      },
      {
        "country_id": "uruguay",
        "label": "ウルグアイ"
      },
      {
        "country_id": "ecuador",
        "label": "エクアドル"
      },
      {
        "country_id": "el-salvador",
        "label": "エルサルバドル"
      },
      {
        "country_id": "guyana",
        "label": "ガイアナ"
      },
      {
        "country_id": "cuba",
        "label": "キューバ"
      },
      {
        "country_id": "guatemala",
        "label": "グアテマラ"
      },
      {
        "country_id": "guadeloupe",
        "label": "グアドループ"
      },
      {
        "country_id": "grenada",
        "label": "グレナダ"
      },
      {
        "country_id": "cayman-islands",
        "label": "ケイマン諸島"
      },
      {
        "country_id": "costa-rica",
        "label": "コスタリカ"
      },
      {
        "country_id": "columbia",
        "label": "コロンビア"
      },
      {
        "country_id": "jamaica",
        "label": "ジャマイカ"
      },
      {
        "country_id": "suriname",
        "label": "スリナム"
      },
      {
        "country_id": "saint-kitts-and-nevis",
        "label": "セントクリストファー・ネービス"
      },
      {
        "country_id": "saint-vincent-and-the-grenadines",
        "label": "セントビンセント及びグレナディーン諸島"
      },
      {
        "country_id": "saint-lucia",
        "label": "セントルシア"
      },
      {
        "country_id": "chile",
        "label": "チリ"
      },
      {
        "country_id": "trinidad-and-tobago",
        "label": "トリニダード・トバゴ"
      },
      {
        "country_id": "dominican-republic",
        "label": "ドミニカ共和国"
      },
      {
        "country_id": "dominica",
        "label": "ドミニカ国"
      },
      {
        "country_id": "nicaragua",
        "label": "ニカラグア共和国"
      },
      {
        "country_id": "haiti",
        "label": "ハイチ共和国"
      },
      {
        "country_id": "bahamas",
        "label": "バハマ"
      },
      {
        "country_id": "barbados",
        "label": "バルバドス"
      },
      {
        "country_id": "panama",
        "label": "パナマ"
      },
      {
        "country_id": "paraguay",
        "label": "パラグアイ"
      },
      {
        "country_id": "french-guiana",
        "label": "フランス領ギアナ"
      },
      {
        "country_id": "brazil",
        "label": "ブラジル"
      },
      {
        "country_id": "puerto-rico",
        "label": "プエルトリコ"
      },
      {
        "country_id": "venezuela",
        "label": "ベネズエラ"
      },
      {
        "country_id": "belize",
        "label": "ベリーズ"
      },
      {
        "country_id": "peru",
        "label": "ペルー"
      },
      {
        "country_id": "honduras",
        "label": "ホンジュラス"
      },
      {
        "country_id": "bolivia",
        "label": "ボリビア"
      },
      {
        "country_id": "martinique",
        "label": "マルティニーク"
      },
      {
        "country_id": "mexico",
        "label": "メキシコ"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/8/mexico/acapulco-de-juarez/",
          "label": "アカプルコ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/paraguay/asuncion/",
          "label": "アスンシオン",
          "country_ja": "パラグアイ"
        },
        {
          "point_id": "/8/peru/ayacucho/",
          "label": "アヤクーチョ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/chile/arica/",
          "label": "アリカ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/peru/arequipa/",
          "label": "アレキパ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/chile/antofagasta/",
          "label": "アントファガスタ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/argentina/puerto-iguazu/",
          "label": "イグアス",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/columbia/ipiales/",
          "label": "イピアレス",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/argentina/ushuaia/",
          "label": "ウシュアイア",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/bolivia/uyuni/",
          "label": "ウユニ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/peru/urubamba/",
          "label": "ウルバンバ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/argentina/el-chalten/",
          "label": "エルチャルテン",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/mexico/ensenada/",
          "label": "エンセナダ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/oaxaca-de-juarez/",
          "label": "オアハカ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/french-guiana/cayenne/",
          "label": "カイエンヌ",
          "country_ja": "フランス領ギアナ"
        },
        {
          "point_id": "/8/saint-lucia/castries/",
          "label": "カストリーズ",
          "country_ja": "セントルシア"
        },
        {
          "point_id": "/8/mexico/cabo-san-lucas/",
          "label": "カボ・サン・ルーカス",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/venezuela/caracas/",
          "label": "カラカス",
          "country_ja": "ベネズエラ"
        },
        {
          "point_id": "/8/argentina/el-calafate/",
          "label": "カラファテ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/columbia/cartagena/",
          "label": "カルタヘナ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/mexico/cancun/",
          "label": "カンクン",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/campeche/",
          "label": "カンペチェ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/brazil/campo-grande/",
          "label": "カンポグランデ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/ecuador/quito/",
          "label": "キト",
          "country_ja": "エクアドル"
        },
        {
          "point_id": "/8/saint-vincent-and-the-grenadines/kingstown/",
          "label": "キングスタウン",
          "country_ja": "セントビンセント及びグレナディーン諸島"
        },
        {
          "point_id": "/8/jamaica/kingston/",
          "label": "キングストン",
          "country_ja": "ジャマイカ"
        },
        {
          "point_id": "/8/brazil/cuiaba/",
          "label": "クイアバ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/peru/cusco/",
          "label": "クスコ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/brazil/curitiba/",
          "label": "クリチバ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/mexico/guadalajara/",
          "label": "グアダラハラ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/guatemala/guatemala-city/",
          "label": "グアテマラ市",
          "country_ja": "グアテマラ"
        },
        {
          "point_id": "/8/nicaragua/granada/",
          "label": "グラナダ",
          "country_ja": "ニカラグア共和国"
        },
        {
          "point_id": "/8/mexico/cozumel/",
          "label": "コスメル",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/bolivia/cochabamba/",
          "label": "コチャバンバ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/argentina/comodoro-rivadavia/",
          "label": "コモドロリバダビア",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/cordoba/",
          "label": "コルドバ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/paraguay/concepcion/",
          "label": "コンセプシオン",
          "country_ja": "パラグアイ"
        },
        {
          "point_id": "/8/brazil/salvador/",
          "label": "サルバドール",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/cuba/sancti-spiritus/",
          "label": "サンクティスピリトゥス",
          "country_ja": "キューバ"
        },
        {
          "point_id": "/8/el-salvador/san-salvador/",
          "label": "サンサルバドル",
          "country_ja": "エルサルバドル"
        },
        {
          "point_id": "/8/bolivia/santa-cruz/",
          "label": "サンタクルス",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/chile/santiago/",
          "label": "サンティアゴ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/dominican-republic/santiago/",
          "label": "サンティアゴ",
          "country_ja": "ドミニカ共和国"
        },
        {
          "point_id": "/8/argentina/santiago-del-estero/",
          "label": "サンティアゴ・デル・エステロ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/brazil/santos/",
          "label": "サントス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/dominican-republic/santo-domingo/",
          "label": "サントドミンゴ",
          "country_ja": "ドミニカ共和国"
        },
        {
          "point_id": "/8/brazil/sao-paulo/",
          "label": "サンパウロ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/puerto-rico/san-juan/",
          "label": "サンファン",
          "country_ja": "プエルトリコ"
        },
        {
          "point_id": "/8/costa-rica/san-jose/",
          "label": "サンホセ",
          "country_ja": "コスタリカ"
        },
        {
          "point_id": "/8/brazil/sao-luis/",
          "label": "サンルイス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/argentina/san-carlos-de-bariloche/",
          "label": "サン・カルロス・デ・バリローチェ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/chile/san-juan-bautista/",
          "label": "サン・ファン・バウティスタ（ロビンソン・クルーソー島）",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/us-virgin-islands/charlotte-amalie/",
          "label": "シャーロット・アマリエ",
          "country_ja": "アメリカ領バージン諸島"
        },
        {
          "point_id": "/8/brazil/juiz-de-fora/",
          "label": "ジュイスデフォラ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/guyana/george-town/",
          "label": "ジョージタウン",
          "country_ja": "ガイアナ"
        },
        {
          "point_id": "/8/cayman-islands/george-town/",
          "label": "ジョージタウン（グランド・ケイマン島）",
          "country_ja": "ケイマン諸島"
        },
        {
          "point_id": "/8/bolivia/sucre/",
          "label": "スクレ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/antigua-and-barbuda/st-johns/",
          "label": "セント・ジョンズ",
          "country_ja": "アンティグア・バーブーダ"
        },
        {
          "point_id": "/8/grenada/saint-georges/",
          "label": "セント・ジョージズ",
          "country_ja": "グレナダ"
        },
        {
          "point_id": "/8/mexico/chihuahua/",
          "label": "チワワ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/honduras/tegucigalpa/",
          "label": "テグシガルパ",
          "country_ja": "ホンジュラス"
        },
        {
          "point_id": "/8/peru/tumbes/",
          "label": "トゥンベス",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/mexico/toluca/",
          "label": "トルカ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/peru/trujillo/",
          "label": "トルヒーヨ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/nazca/",
          "label": "ナスカ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/bahamas/nassau/",
          "label": "ナッソー",
          "country_ja": "バハマ"
        },
        {
          "point_id": "/8/cuba/havana/",
          "label": "ハバナ",
          "country_ja": "キューバ"
        },
        {
          "point_id": "/8/chile/hanga-roa/",
          "label": "ハンガロア（イースター島）",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/argentina/bahia-blanca/",
          "label": "バイアブランカ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/guadeloupe/basse-terre/",
          "label": "バステール",
          "country_ja": "グアドループ"
        },
        {
          "point_id": "/8/saint-kitts-and-nevis/basseterre/",
          "label": "バセテール",
          "country_ja": "セントクリストファー・ネービス"
        },
        {
          "point_id": "/8/brazil/barreirinhas/",
          "label": "バヘイリーニャス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/columbia/barranquilla/",
          "label": "バランキージャ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/barbados/barbados/",
          "label": "バルバドス島",
          "country_ja": "バルバドス"
        },
        {
          "point_id": "/8/panama/panama-city/",
          "label": "パナマシティー",
          "country_ja": "パナマ"
        },
        {
          "point_id": "/8/peru/paracas/",
          "label": "パラカス",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/suriname/paramaribo/",
          "label": "パラマリボ",
          "country_ja": "スリナム"
        },
        {
          "point_id": "/8/mexico/villahermosa/",
          "label": "ビヤエルモサ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/peru/pisco/",
          "label": "ピスコ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/brazil/fortaleza/",
          "label": "フォルタレザ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/martinique/fort-de-france/",
          "label": "フォール・ド・フランス",
          "country_ja": "マルティニーク"
        },
        {
          "point_id": "/8/peru/juliaca/",
          "label": "フリアカ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/guatemala/flores/",
          "label": "フローレス",
          "country_ja": "グアテマラ"
        },
        {
          "point_id": "/8/argentina/buenos-aires/",
          "label": "ブエノスアイレス",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/brazil/brasilia/",
          "label": "ブラジリア",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/barbados/bridgetown/",
          "label": "ブリッジタウン",
          "country_ja": "バルバドス"
        },
        {
          "point_id": "/8/mexico/puebla/",
          "label": "プエブラ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/progreso/",
          "label": "プログレソ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/chile/punta-arenas/",
          "label": "プンタアレナス",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/peru/puno/",
          "label": "プーノ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/belize/belize-city/",
          "label": "ベリーズシティ",
          "country_ja": "ベリーズ"
        },
        {
          "point_id": "/8/belize/belmopan/",
          "label": "ベルモパン",
          "country_ja": "ベリーズ"
        },
        {
          "point_id": "/8/brazil/belem/",
          "label": "ベレン",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/belo-horizonte/",
          "label": "ベロオリゾンテ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/columbia/bogota/",
          "label": "ボゴタ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/guadeloupe/pointe-a-pitre/",
          "label": "ポアント・ア・ピトル",
          "country_ja": "グアドループ"
        },
        {
          "point_id": "/8/brazil/porto-velho/",
          "label": "ポルト・ベリョ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/haiti/port-au-prince/",
          "label": "ポルトー・プランス",
          "country_ja": "ハイチ共和国"
        },
        {
          "point_id": "/8/trinidad-and-tobago/port-of-spain/",
          "label": "ポートオブスペイン",
          "country_ja": "トリニダード・トバゴ"
        },
        {
          "point_id": "/8/cuba/matanzas/",
          "label": "マタンサス",
          "country_ja": "キューバ"
        },
        {
          "point_id": "/8/brazil/manaus/",
          "label": "マナウス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/nicaragua/managua/",
          "label": "マナグア",
          "country_ja": "ニカラグア共和国"
        },
        {
          "point_id": "/8/mexico/mexico-city/",
          "label": "メキシコ・シティ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/merida/",
          "label": "メリダ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/argentina/mendoza/",
          "label": "メンドサ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/jamaica/montego-bay/",
          "label": "モンテゴベイ",
          "country_ja": "ジャマイカ"
        },
        {
          "point_id": "/8/uruguay/montevideo/",
          "label": "モンテビデオ",
          "country_ja": "ウルグアイ"
        },
        {
          "point_id": "/8/columbia/monteria/",
          "label": "モンテリア",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/mexico/monterrey/",
          "label": "モンテレー",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/la-paz/",
          "label": "ラパス",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/bolivia/la-paz/",
          "label": "ラパス",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/argentina/rio-gallegos/",
          "label": "リオガジェゴス",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/brazil/rio-de-janeiro/",
          "label": "リオデジャネイロ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/peru/lima/",
          "label": "リマ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/brazil/recife/",
          "label": "レシフェ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/dominica/roseau/",
          "label": "ロゾー",
          "country_ja": "ドミニカ国"
        }
      ],
      "mexico": [
        {
          "point_id": "/8/mexico/acapulco-de-juarez/",
          "label": "アカプルコ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/ensenada/",
          "label": "エンセナダ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/oaxaca-de-juarez/",
          "label": "オアハカ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/cabo-san-lucas/",
          "label": "カボ・サン・ルーカス",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/cancun/",
          "label": "カンクン",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/campeche/",
          "label": "カンペチェ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/guadalajara/",
          "label": "グアダラハラ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/cozumel/",
          "label": "コスメル",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/chihuahua/",
          "label": "チワワ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/toluca/",
          "label": "トルカ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/villahermosa/",
          "label": "ビヤエルモサ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/puebla/",
          "label": "プエブラ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/progreso/",
          "label": "プログレソ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/mexico-city/",
          "label": "メキシコ・シティ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/merida/",
          "label": "メリダ",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/monterrey/",
          "label": "モンテレー",
          "country_ja": "メキシコ"
        },
        {
          "point_id": "/8/mexico/la-paz/",
          "label": "ラパス",
          "country_ja": "メキシコ"
        }
      ],
      "us-virgin-islands": [
        {
          "point_id": "/8/us-virgin-islands/charlotte-amalie/",
          "label": "シャーロット・アマリエ",
          "country_ja": "アメリカ領バージン諸島"
        }
      ],
      "argentina": [
        {
          "point_id": "/8/argentina/puerto-iguazu/",
          "label": "イグアス",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/ushuaia/",
          "label": "ウシュアイア",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/el-chalten/",
          "label": "エルチャルテン",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/el-calafate/",
          "label": "カラファテ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/comodoro-rivadavia/",
          "label": "コモドロリバダビア",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/cordoba/",
          "label": "コルドバ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/santiago-del-estero/",
          "label": "サンティアゴ・デル・エステロ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/san-carlos-de-bariloche/",
          "label": "サン・カルロス・デ・バリローチェ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/bahia-blanca/",
          "label": "バイアブランカ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/buenos-aires/",
          "label": "ブエノスアイレス",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/mendoza/",
          "label": "メンドサ",
          "country_ja": "アルゼンチン"
        },
        {
          "point_id": "/8/argentina/rio-gallegos/",
          "label": "リオガジェゴス",
          "country_ja": "アルゼンチン"
        }
      ],
      "uruguay": [
        {
          "point_id": "/8/uruguay/montevideo/",
          "label": "モンテビデオ",
          "country_ja": "ウルグアイ"
        }
      ],
      "ecuador": [
        {
          "point_id": "/8/ecuador/quito/",
          "label": "キト",
          "country_ja": "エクアドル"
        }
      ],
      "el-salvador": [
        {
          "point_id": "/8/el-salvador/san-salvador/",
          "label": "サンサルバドル",
          "country_ja": "エルサルバドル"
        }
      ],
      "guyana": [
        {
          "point_id": "/8/guyana/george-town/",
          "label": "ジョージタウン",
          "country_ja": "ガイアナ"
        }
      ],
      "cuba": [
        {
          "point_id": "/8/cuba/sancti-spiritus/",
          "label": "サンクティスピリトゥス",
          "country_ja": "キューバ"
        },
        {
          "point_id": "/8/cuba/havana/",
          "label": "ハバナ",
          "country_ja": "キューバ"
        },
        {
          "point_id": "/8/cuba/matanzas/",
          "label": "マタンサス",
          "country_ja": "キューバ"
        }
      ],
      "guatemala": [
        {
          "point_id": "/8/guatemala/guatemala-city/",
          "label": "グアテマラ市",
          "country_ja": "グアテマラ"
        },
        {
          "point_id": "/8/guatemala/flores/",
          "label": "フローレス",
          "country_ja": "グアテマラ"
        }
      ],
      "guadeloupe": [
        {
          "point_id": "/8/guadeloupe/basse-terre/",
          "label": "バステール",
          "country_ja": "グアドループ"
        },
        {
          "point_id": "/8/guadeloupe/pointe-a-pitre/",
          "label": "ポアント・ア・ピトル",
          "country_ja": "グアドループ"
        }
      ],
      "costa-rica": [
        {
          "point_id": "/8/costa-rica/san-jose/",
          "label": "サンホセ",
          "country_ja": "コスタリカ"
        }
      ],
      "columbia": [
        {
          "point_id": "/8/columbia/ipiales/",
          "label": "イピアレス",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/columbia/cartagena/",
          "label": "カルタヘナ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/columbia/barranquilla/",
          "label": "バランキージャ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/columbia/bogota/",
          "label": "ボゴタ",
          "country_ja": "コロンビア"
        },
        {
          "point_id": "/8/columbia/monteria/",
          "label": "モンテリア",
          "country_ja": "コロンビア"
        }
      ],
      "jamaica": [
        {
          "point_id": "/8/jamaica/kingston/",
          "label": "キングストン",
          "country_ja": "ジャマイカ"
        },
        {
          "point_id": "/8/jamaica/montego-bay/",
          "label": "モンテゴベイ",
          "country_ja": "ジャマイカ"
        }
      ],
      "suriname": [
        {
          "point_id": "/8/suriname/paramaribo/",
          "label": "パラマリボ",
          "country_ja": "スリナム"
        }
      ],
      "saint-lucia": [
        {
          "point_id": "/8/saint-lucia/castries/",
          "label": "カストリーズ",
          "country_ja": "セントルシア"
        }
      ],
      "chile": [
        {
          "point_id": "/8/chile/arica/",
          "label": "アリカ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/chile/antofagasta/",
          "label": "アントファガスタ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/chile/santiago/",
          "label": "サンティアゴ",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/chile/san-juan-bautista/",
          "label": "サン・ファン・バウティスタ（ロビンソン・クルーソー島）",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/chile/hanga-roa/",
          "label": "ハンガロア（イースター島）",
          "country_ja": "チリ"
        },
        {
          "point_id": "/8/chile/punta-arenas/",
          "label": "プンタアレナス",
          "country_ja": "チリ"
        }
      ],
      "trinidad-and-tobago": [
        {
          "point_id": "/8/trinidad-and-tobago/port-of-spain/",
          "label": "ポートオブスペイン",
          "country_ja": "トリニダード・トバゴ"
        }
      ],
      "dominican-republic": [
        {
          "point_id": "/8/dominican-republic/santiago/",
          "label": "サンティアゴ",
          "country_ja": "ドミニカ共和国"
        },
        {
          "point_id": "/8/dominican-republic/santo-domingo/",
          "label": "サントドミンゴ",
          "country_ja": "ドミニカ共和国"
        }
      ],
      "bahamas": [
        {
          "point_id": "/8/bahamas/nassau/",
          "label": "ナッソー",
          "country_ja": "バハマ"
        }
      ],
      "barbados": [
        {
          "point_id": "/8/barbados/barbados/",
          "label": "バルバドス島",
          "country_ja": "バルバドス"
        },
        {
          "point_id": "/8/barbados/bridgetown/",
          "label": "ブリッジタウン",
          "country_ja": "バルバドス"
        }
      ],
      "panama": [
        {
          "point_id": "/8/panama/panama-city/",
          "label": "パナマシティー",
          "country_ja": "パナマ"
        }
      ],
      "paraguay": [
        {
          "point_id": "/8/paraguay/asuncion/",
          "label": "アスンシオン",
          "country_ja": "パラグアイ"
        },
        {
          "point_id": "/8/paraguay/concepcion/",
          "label": "コンセプシオン",
          "country_ja": "パラグアイ"
        }
      ],
      "french-guiana": [
        {
          "point_id": "/8/french-guiana/cayenne/",
          "label": "カイエンヌ",
          "country_ja": "フランス領ギアナ"
        }
      ],
      "brazil": [
        {
          "point_id": "/8/brazil/campo-grande/",
          "label": "カンポグランデ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/cuiaba/",
          "label": "クイアバ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/curitiba/",
          "label": "クリチバ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/salvador/",
          "label": "サルバドール",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/santos/",
          "label": "サントス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/sao-paulo/",
          "label": "サンパウロ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/sao-luis/",
          "label": "サンルイス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/juiz-de-fora/",
          "label": "ジュイスデフォラ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/barreirinhas/",
          "label": "バヘイリーニャス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/fortaleza/",
          "label": "フォルタレザ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/brasilia/",
          "label": "ブラジリア",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/belem/",
          "label": "ベレン",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/belo-horizonte/",
          "label": "ベロオリゾンテ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/porto-velho/",
          "label": "ポルト・ベリョ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/manaus/",
          "label": "マナウス",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/rio-de-janeiro/",
          "label": "リオデジャネイロ",
          "country_ja": "ブラジル"
        },
        {
          "point_id": "/8/brazil/recife/",
          "label": "レシフェ",
          "country_ja": "ブラジル"
        }
      ],
      "puerto-rico": [
        {
          "point_id": "/8/puerto-rico/san-juan/",
          "label": "サンファン",
          "country_ja": "プエルトリコ"
        }
      ],
      "venezuela": [
        {
          "point_id": "/8/venezuela/caracas/",
          "label": "カラカス",
          "country_ja": "ベネズエラ"
        }
      ],
      "belize": [
        {
          "point_id": "/8/belize/belize-city/",
          "label": "ベリーズシティ",
          "country_ja": "ベリーズ"
        },
        {
          "point_id": "/8/belize/belmopan/",
          "label": "ベルモパン",
          "country_ja": "ベリーズ"
        }
      ],
      "peru": [
        {
          "point_id": "/8/peru/ayacucho/",
          "label": "アヤクーチョ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/arequipa/",
          "label": "アレキパ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/urubamba/",
          "label": "ウルバンバ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/cusco/",
          "label": "クスコ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/tumbes/",
          "label": "トゥンベス",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/trujillo/",
          "label": "トルヒーヨ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/nazca/",
          "label": "ナスカ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/paracas/",
          "label": "パラカス",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/pisco/",
          "label": "ピスコ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/juliaca/",
          "label": "フリアカ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/puno/",
          "label": "プーノ",
          "country_ja": "ペルー"
        },
        {
          "point_id": "/8/peru/lima/",
          "label": "リマ",
          "country_ja": "ペルー"
        }
      ],
      "honduras": [
        {
          "point_id": "/8/honduras/tegucigalpa/",
          "label": "テグシガルパ",
          "country_ja": "ホンジュラス"
        }
      ],
      "bolivia": [
        {
          "point_id": "/8/bolivia/uyuni/",
          "label": "ウユニ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/bolivia/cochabamba/",
          "label": "コチャバンバ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/bolivia/santa-cruz/",
          "label": "サンタクルス",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/bolivia/sucre/",
          "label": "スクレ",
          "country_ja": "ボリビア"
        },
        {
          "point_id": "/8/bolivia/la-paz/",
          "label": "ラパス",
          "country_ja": "ボリビア"
        }
      ],
      "martinique": [
        {
          "point_id": "/8/martinique/fort-de-france/",
          "label": "フォール・ド・フランス",
          "country_ja": "マルティニーク"
        }
      ],
      "antigua-and-barbuda": [
        {
          "point_id": "/8/antigua-and-barbuda/st-johns/",
          "label": "セント・ジョンズ",
          "country_ja": "アンティグア・バーブーダ"
        }
      ],
      "dominica": [
        {
          "point_id": "/8/dominica/roseau/",
          "label": "ロゾー",
          "country_ja": "ドミニカ国"
        }
      ],
      "saint-kitts-and-nevis": [
        {
          "point_id": "/8/saint-kitts-and-nevis/basseterre/",
          "label": "バセテール",
          "country_ja": "セントクリストファー・ネービス"
        }
      ],
      "grenada": [
        {
          "point_id": "/8/grenada/saint-georges/",
          "label": "セント・ジョージズ",
          "country_ja": "グレナダ"
        }
      ],
      "saint-vincent-and-the-grenadines": [
        {
          "point_id": "/8/saint-vincent-and-the-grenadines/kingstown/",
          "label": "キングスタウン",
          "country_ja": "セントビンセント及びグレナディーン諸島"
        }
      ],
      "nicaragua": [
        {
          "point_id": "/8/nicaragua/granada/",
          "label": "グラナダ",
          "country_ja": "ニカラグア共和国"
        },
        {
          "point_id": "/8/nicaragua/managua/",
          "label": "マナグア",
          "country_ja": "ニカラグア共和国"
        }
      ],
      "haiti": [
        {
          "point_id": "/8/haiti/port-au-prince/",
          "label": "ポルトー・プランス",
          "country_ja": "ハイチ共和国"
        }
      ],
      "cayman-islands": [
        {
          "point_id": "/8/cayman-islands/george-town/",
          "label": "ジョージタウン（グランド・ケイマン島）",
          "country_ja": "ケイマン諸島"
        }
      ]
    }
  },
  "4": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "afghanistan",
        "label": "アフガニスタン"
      },
      {
        "country_id": "uae",
        "label": "アラブ首長国連邦"
      },
      {
        "country_id": "yemen",
        "label": "イエメン"
      },
      {
        "country_id": "israel",
        "label": "イスラエル"
      },
      {
        "country_id": "iraq",
        "label": "イラク"
      },
      {
        "country_id": "iran",
        "label": "イラン"
      },
      {
        "country_id": "uzbekistan",
        "label": "ウズベキスタン"
      },
      {
        "country_id": "oman",
        "label": "オマーン"
      },
      {
        "country_id": "kazakhstan",
        "label": "カザフスタン"
      },
      {
        "country_id": "qatar",
        "label": "カタール"
      },
      {
        "country_id": "cyprus",
        "label": "キプロス"
      },
      {
        "country_id": "kyrgyzstan",
        "label": "キルギス"
      },
      {
        "country_id": "kuwait",
        "label": "クウェート"
      },
      {
        "country_id": "saudi-arabia",
        "label": "サウジアラビア"
      },
      {
        "country_id": "syria",
        "label": "シリア"
      },
      {
        "country_id": "tajikistan",
        "label": "タジキスタン"
      },
      {
        "country_id": "turkmenistan",
        "label": "トルクメニスタン"
      },
      {
        "country_id": "turkiye",
        "label": "トルコ"
      },
      {
        "country_id": "bahrain",
        "label": "バーレーン"
      },
      {
        "country_id": "jordan",
        "label": "ヨルダン"
      },
      {
        "country_id": "lebanon",
        "label": "レバノン"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/4/turkiye/ayvalik/",
          "label": "アイワルク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/aksaray/",
          "label": "アクサライ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkmenistan/ashgabat/",
          "label": "アシガバット",
          "country_ja": "トルクメニスタン"
        },
        {
          "point_id": "/4/kazakhstan/astana/",
          "label": "アスタナ",
          "country_ja": "カザフスタン"
        },
        {
          "point_id": "/4/uae/abu-dhabi/",
          "label": "アブダビ",
          "country_ja": "アラブ首長国連邦"
        },
        {
          "point_id": "/4/kazakhstan/almaty/",
          "label": "アルマティ",
          "country_ja": "カザフスタン"
        },
        {
          "point_id": "/4/syria/aleppo/",
          "label": "アレッポ",
          "country_ja": "シリア"
        },
        {
          "point_id": "/4/turkiye/ankara/",
          "label": "アンカラ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/antalya/",
          "label": "アンタルヤ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/jordan/amman/",
          "label": "アンマン",
          "country_ja": "ヨルダン"
        },
        {
          "point_id": "/4/turkiye/istanbul/",
          "label": "イスタンブール",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/izmir/",
          "label": "イズミル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/isparta/",
          "label": "ウスパルタ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/uzbekistan/urgench/",
          "label": "ウルゲンチ",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/iran/isfahan/",
          "label": "エスファハーン",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/israel/jerusalem/",
          "label": "エルサレム",
          "country_ja": "イスラエル"
        },
        {
          "point_id": "/4/turkiye/kayseri/",
          "label": "カイセリ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/afghanistan/kabul/",
          "label": "カブール",
          "country_ja": "アフガニスタン"
        },
        {
          "point_id": "/4/kuwait/kuwait/",
          "label": "クウェート",
          "country_ja": "クウェート"
        },
        {
          "point_id": "/4/turkiye/kusadasi/",
          "label": "クシャダス",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/iran/kermanshah/",
          "label": "ケルマーンシャー",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/turkiye/konya/",
          "label": "コンヤ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/yemen/sanaa/",
          "label": "サヌア",
          "country_ja": "イエメン"
        },
        {
          "point_id": "/4/turkiye/safranbolu/",
          "label": "サフランボル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/uzbekistan/samarqand/",
          "label": "サマルカンド",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/oman/salalah/",
          "label": "サラーラ",
          "country_ja": "オマーン"
        },
        {
          "point_id": "/4/iran/shiraz/",
          "label": "シラーズ",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/saudi-arabia/jeddah/",
          "label": "ジッダ",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/turkiye/selcuk/",
          "label": "セルチュク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/zonguldak/",
          "label": "ゾングルダク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/uzbekistan/tashkent/",
          "label": "タシケント",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/syria/damascus/",
          "label": "ダマスカス",
          "country_ja": "シリア"
        },
        {
          "point_id": "/4/saudi-arabia/dhahran/",
          "label": "ダーラン",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/iran/tehran/",
          "label": "テヘラン",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/kazakhstan/turkestan/",
          "label": "テュルキスタン",
          "country_ja": "カザフスタン"
        },
        {
          "point_id": "/4/turkiye/diyarbakir/",
          "label": "ディヤルバクル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/lebanon/tripoli/",
          "label": "トリポリ",
          "country_ja": "レバノン"
        },
        {
          "point_id": "/4/turkmenistan/turkmenbashi/",
          "label": "トルクメンバシ",
          "country_ja": "トルクメニスタン"
        },
        {
          "point_id": "/4/tajikistan/dushanbe/",
          "label": "ドゥシャンベ",
          "country_ja": "タジキスタン"
        },
        {
          "point_id": "/4/uae/dubai/",
          "label": "ドバイ",
          "country_ja": "アラブ首長国連邦"
        },
        {
          "point_id": "/4/qatar/doha/",
          "label": "ドーハ",
          "country_ja": "カタール"
        },
        {
          "point_id": "/4/kyrgyzstan/naryn/",
          "label": "ナルイン",
          "country_ja": "キルギス"
        },
        {
          "point_id": "/4/cyprus/nicosia/",
          "label": "ニコシア",
          "country_ja": "キプロス"
        },
        {
          "point_id": "/4/israel/haifa/",
          "label": "ハイファ",
          "country_ja": "イスラエル"
        },
        {
          "point_id": "/4/iraq/baghdad/",
          "label": "バグダッド",
          "country_ja": "イラク"
        },
        {
          "point_id": "/4/syria/palmyra/",
          "label": "パルミラ",
          "country_ja": "シリア"
        },
        {
          "point_id": "/4/kyrgyzstan/bishkek/",
          "label": "ビシュケク",
          "country_ja": "キルギス"
        },
        {
          "point_id": "/4/uzbekistan/bukhara/",
          "label": "ブハラ",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/lebanon/beirut/",
          "label": "ベイルート",
          "country_ja": "レバノン"
        },
        {
          "point_id": "/4/turkiye/bergama/",
          "label": "ベルガマ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/bogazkale/",
          "label": "ボアズカレ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/bodrum/",
          "label": "ボドルム",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/jordan/maan/",
          "label": "マアーン",
          "country_ja": "ヨルダン"
        },
        {
          "point_id": "/4/oman/muscat/",
          "label": "マスカット",
          "country_ja": "オマーン"
        },
        {
          "point_id": "/4/bahrain/manama/",
          "label": "マナーマ",
          "country_ja": "バーレーン"
        },
        {
          "point_id": "/4/saudi-arabia/mecca/",
          "label": "メッカ",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/cyprus/larnaca/",
          "label": "ラルナカ",
          "country_ja": "キプロス"
        },
        {
          "point_id": "/4/saudi-arabia/riyadh/",
          "label": "リヤド",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/jordan/wadi-musa/",
          "label": "ワディ・ムサ",
          "country_ja": "ヨルダン"
        }
      ],
      "afghanistan": [
        {
          "point_id": "/4/afghanistan/kabul/",
          "label": "カブール",
          "country_ja": "アフガニスタン"
        }
      ],
      "uae": [
        {
          "point_id": "/4/uae/abu-dhabi/",
          "label": "アブダビ",
          "country_ja": "アラブ首長国連邦"
        },
        {
          "point_id": "/4/uae/dubai/",
          "label": "ドバイ",
          "country_ja": "アラブ首長国連邦"
        }
      ],
      "yemen": [
        {
          "point_id": "/4/yemen/sanaa/",
          "label": "サヌア",
          "country_ja": "イエメン"
        }
      ],
      "israel": [
        {
          "point_id": "/4/israel/jerusalem/",
          "label": "エルサレム",
          "country_ja": "イスラエル"
        },
        {
          "point_id": "/4/israel/haifa/",
          "label": "ハイファ",
          "country_ja": "イスラエル"
        }
      ],
      "iraq": [
        {
          "point_id": "/4/iraq/baghdad/",
          "label": "バグダッド",
          "country_ja": "イラク"
        }
      ],
      "iran": [
        {
          "point_id": "/4/iran/isfahan/",
          "label": "エスファハーン",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/iran/kermanshah/",
          "label": "ケルマーンシャー",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/iran/shiraz/",
          "label": "シラーズ",
          "country_ja": "イラン"
        },
        {
          "point_id": "/4/iran/tehran/",
          "label": "テヘラン",
          "country_ja": "イラン"
        }
      ],
      "uzbekistan": [
        {
          "point_id": "/4/uzbekistan/urgench/",
          "label": "ウルゲンチ",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/uzbekistan/samarqand/",
          "label": "サマルカンド",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/uzbekistan/tashkent/",
          "label": "タシケント",
          "country_ja": "ウズベキスタン"
        },
        {
          "point_id": "/4/uzbekistan/bukhara/",
          "label": "ブハラ",
          "country_ja": "ウズベキスタン"
        }
      ],
      "oman": [
        {
          "point_id": "/4/oman/salalah/",
          "label": "サラーラ",
          "country_ja": "オマーン"
        },
        {
          "point_id": "/4/oman/muscat/",
          "label": "マスカット",
          "country_ja": "オマーン"
        }
      ],
      "kazakhstan": [
        {
          "point_id": "/4/kazakhstan/astana/",
          "label": "アスタナ",
          "country_ja": "カザフスタン"
        },
        {
          "point_id": "/4/kazakhstan/almaty/",
          "label": "アルマティ",
          "country_ja": "カザフスタン"
        },
        {
          "point_id": "/4/kazakhstan/turkestan/",
          "label": "テュルキスタン",
          "country_ja": "カザフスタン"
        }
      ],
      "qatar": [
        {
          "point_id": "/4/qatar/doha/",
          "label": "ドーハ",
          "country_ja": "カタール"
        }
      ],
      "cyprus": [
        {
          "point_id": "/4/cyprus/nicosia/",
          "label": "ニコシア",
          "country_ja": "キプロス"
        },
        {
          "point_id": "/4/cyprus/larnaca/",
          "label": "ラルナカ",
          "country_ja": "キプロス"
        }
      ],
      "kyrgyzstan": [
        {
          "point_id": "/4/kyrgyzstan/naryn/",
          "label": "ナルイン",
          "country_ja": "キルギス"
        },
        {
          "point_id": "/4/kyrgyzstan/bishkek/",
          "label": "ビシュケク",
          "country_ja": "キルギス"
        }
      ],
      "kuwait": [
        {
          "point_id": "/4/kuwait/kuwait/",
          "label": "クウェート",
          "country_ja": "クウェート"
        }
      ],
      "saudi-arabia": [
        {
          "point_id": "/4/saudi-arabia/jeddah/",
          "label": "ジッダ",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/saudi-arabia/dhahran/",
          "label": "ダーラン",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/saudi-arabia/mecca/",
          "label": "メッカ",
          "country_ja": "サウジアラビア"
        },
        {
          "point_id": "/4/saudi-arabia/riyadh/",
          "label": "リヤド",
          "country_ja": "サウジアラビア"
        }
      ],
      "syria": [
        {
          "point_id": "/4/syria/aleppo/",
          "label": "アレッポ",
          "country_ja": "シリア"
        },
        {
          "point_id": "/4/syria/damascus/",
          "label": "ダマスカス",
          "country_ja": "シリア"
        },
        {
          "point_id": "/4/syria/palmyra/",
          "label": "パルミラ",
          "country_ja": "シリア"
        }
      ],
      "tajikistan": [
        {
          "point_id": "/4/tajikistan/dushanbe/",
          "label": "ドゥシャンベ",
          "country_ja": "タジキスタン"
        }
      ],
      "turkmenistan": [
        {
          "point_id": "/4/turkmenistan/ashgabat/",
          "label": "アシガバット",
          "country_ja": "トルクメニスタン"
        },
        {
          "point_id": "/4/turkmenistan/turkmenbashi/",
          "label": "トルクメンバシ",
          "country_ja": "トルクメニスタン"
        }
      ],
      "turkiye": [
        {
          "point_id": "/4/turkiye/ayvalik/",
          "label": "アイワルク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/aksaray/",
          "label": "アクサライ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/ankara/",
          "label": "アンカラ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/antalya/",
          "label": "アンタルヤ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/istanbul/",
          "label": "イスタンブール",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/izmir/",
          "label": "イズミル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/isparta/",
          "label": "ウスパルタ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/kayseri/",
          "label": "カイセリ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/kusadasi/",
          "label": "クシャダス",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/konya/",
          "label": "コンヤ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/safranbolu/",
          "label": "サフランボル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/selcuk/",
          "label": "セルチュク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/zonguldak/",
          "label": "ゾングルダク",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/diyarbakir/",
          "label": "ディヤルバクル",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/bergama/",
          "label": "ベルガマ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/bogazkale/",
          "label": "ボアズカレ",
          "country_ja": "トルコ"
        },
        {
          "point_id": "/4/turkiye/bodrum/",
          "label": "ボドルム",
          "country_ja": "トルコ"
        }
      ],
      "bahrain": [
        {
          "point_id": "/4/bahrain/manama/",
          "label": "マナーマ",
          "country_ja": "バーレーン"
        }
      ],
      "jordan": [
        {
          "point_id": "/4/jordan/amman/",
          "label": "アンマン",
          "country_ja": "ヨルダン"
        },
        {
          "point_id": "/4/jordan/maan/",
          "label": "マアーン",
          "country_ja": "ヨルダン"
        },
        {
          "point_id": "/4/jordan/wadi-musa/",
          "label": "ワディ・ムサ",
          "country_ja": "ヨルダン"
        }
      ],
      "lebanon": [
        {
          "point_id": "/4/lebanon/tripoli/",
          "label": "トリポリ",
          "country_ja": "レバノン"
        },
        {
          "point_id": "/4/lebanon/beirut/",
          "label": "ベイルート",
          "country_ja": "レバノン"
        }
      ]
    }
  },
  "9": {
    "countries": [
      {
        "country_id": "all",
        "label": "すべて"
      },
      {
        "country_id": "algeria",
        "label": "アルジェリア"
      },
      {
        "country_id": "angola",
        "label": "アンゴラ"
      },
      {
        "country_id": "uganda",
        "label": "ウガンダ"
      },
      {
        "country_id": "egypt",
        "label": "エジプト"
      },
      {
        "country_id": "eswatini",
        "label": "エスワティニ王国"
      },
      {
        "country_id": "ethiopia",
        "label": "エチオピア"
      },
      {
        "country_id": "eritrea",
        "label": "エリトリア国"
      },
      {
        "country_id": "cameroon",
        "label": "カメルーン"
      },
      {
        "country_id": "cape-verde",
        "label": "カーボベルデ"
      },
      {
        "country_id": "gabon",
        "label": "ガボン"
      },
      {
        "country_id": "gambia",
        "label": "ガンビア"
      },
      {
        "country_id": "ghana",
        "label": "ガーナ共和国"
      },
      {
        "country_id": "guinea",
        "label": "ギニア"
      },
      {
        "country_id": "guinea-bissau",
        "label": "ギニアビサウ共和国"
      },
      {
        "country_id": "kenya",
        "label": "ケニア"
      },
      {
        "country_id": "comoros",
        "label": "コモロ連合"
      },
      {
        "country_id": "republic-of-the-congo",
        "label": "コンゴ共和国"
      },
      {
        "country_id": "democratic-republic-of-the-congo",
        "label": "コンゴ民主共和国"
      },
      {
        "country_id": "ivory-coast",
        "label": "コートジボワール"
      },
      {
        "country_id": "sao-tome-and-principe",
        "label": "サントメ・プリンシペ民主共和国"
      },
      {
        "country_id": "zambia",
        "label": "ザンビア共和国"
      },
      {
        "country_id": "sierra-leone",
        "label": "シエラレオネ共和国"
      },
      {
        "country_id": "djibouti",
        "label": "ジブチ共和国"
      },
      {
        "country_id": "zimbabwe",
        "label": "ジンバブエ"
      },
      {
        "country_id": "sudan",
        "label": "スーダン"
      },
      {
        "country_id": "senegal",
        "label": "セネガル"
      },
      {
        "country_id": "saint-helena-islands",
        "label": "セントヘレナ諸島"
      },
      {
        "country_id": "seychelles",
        "label": "セーシェル"
      },
      {
        "country_id": "somalia",
        "label": "ソマリア連邦共和国"
      },
      {
        "country_id": "tanzania",
        "label": "タンザニア"
      },
      {
        "country_id": "chad",
        "label": "チャド"
      },
      {
        "country_id": "tunisia",
        "label": "チュニジア"
      },
      {
        "country_id": "togo",
        "label": "トーゴ"
      },
      {
        "country_id": "nigeria",
        "label": "ナイジェリア連邦共和国"
      },
      {
        "country_id": "namibia",
        "label": "ナミビア"
      },
      {
        "country_id": "niger",
        "label": "ニジェール"
      },
      {
        "country_id": "burkina-faso",
        "label": "ブルキナファソ"
      },
      {
        "country_id": "burundi",
        "label": "ブルンジ共和国"
      },
      {
        "country_id": "benin",
        "label": "ベナン"
      },
      {
        "country_id": "botswana",
        "label": "ボツワナ"
      },
      {
        "country_id": "madagascar",
        "label": "マダガスカル"
      },
      {
        "country_id": "malawi",
        "label": "マラウイ共和国"
      },
      {
        "country_id": "mali",
        "label": "マリ"
      },
      {
        "country_id": "mozambique",
        "label": "モザンビーク"
      },
      {
        "country_id": "morocco",
        "label": "モロッコ"
      },
      {
        "country_id": "mauritius",
        "label": "モーリシャス共和国"
      },
      {
        "country_id": "mauritania",
        "label": "モーリタニア"
      },
      {
        "country_id": "libya",
        "label": "リビア"
      },
      {
        "country_id": "liberia",
        "label": "リベリア共和国"
      },
      {
        "country_id": "rwanda",
        "label": "ルワンダ共和国"
      },
      {
        "country_id": "lesotho",
        "label": "レソト王国"
      },
      {
        "country_id": "central-african-republic",
        "label": "中央アフリカ共和国"
      },
      {
        "country_id": "south-africa",
        "label": "南アフリカ共和国"
      },
      {
        "country_id": "south-sudan",
        "label": "南スーダン"
      },
      {
        "country_id": "equatorial-guinea",
        "label": "赤道ギニア共和国"
      }
    ],
    "points": {
      "all": [
        {
          "point_id": "/9/ghana/accra/",
          "label": "アクラ",
          "country_ja": "ガーナ共和国"
        },
        {
          "point_id": "/9/eritrea/asmara/",
          "label": "アスマラ",
          "country_ja": "エリトリア国"
        },
        {
          "point_id": "/9/egypt/aswan/",
          "label": "アスワン",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/ethiopia/addis-ababa/",
          "label": "アディスアベバ",
          "country_ja": "エチオピア"
        },
        {
          "point_id": "/9/egypt/abu-simbel/",
          "label": "アブシンベル",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/nigeria/abuja/",
          "label": "アブジャ",
          "country_ja": "ナイジェリア連邦共和国"
        },
        {
          "point_id": "/9/uganda/arua/",
          "label": "アルア",
          "country_ja": "ウガンダ"
        },
        {
          "point_id": "/9/algeria/algiers/",
          "label": "アルジェ",
          "country_ja": "アルジェリア"
        },
        {
          "point_id": "/9/egypt/alexandria/",
          "label": "アレクサンドリア",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/madagascar/antananarivo/",
          "label": "アンタナナリボ",
          "country_ja": "マダガスカル"
        },
        {
          "point_id": "/9/namibia/windhoek/",
          "label": "ウィントフーク",
          "country_ja": "ナミビア"
        },
        {
          "point_id": "/9/namibia/walvis-bay/",
          "label": "ウォルビス・ベイ",
          "country_ja": "ナミビア"
        },
        {
          "point_id": "/9/libya/aubery/",
          "label": "ウバリ",
          "country_ja": "リビア"
        },
        {
          "point_id": "/9/egypt/edfu/",
          "label": "エドフ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/tunisia/el-djem/",
          "label": "エルジャム",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/morocco/erfoud/",
          "label": "エルフード",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/uganda/entebbe/",
          "label": "エンテベ",
          "country_ja": "ウガンダ"
        },
        {
          "point_id": "/9/egypt/cairo/",
          "label": "カイロ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/senegal/kaolack/",
          "label": "カオラック",
          "country_ja": "セネガル"
        },
        {
          "point_id": "/9/morocco/casablanca/",
          "label": "カサブランカ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/uganda/kampala/",
          "label": "カンパラ",
          "country_ja": "ウガンダ"
        },
        {
          "point_id": "/9/tunisia/gabes/",
          "label": "ガベス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/rwanda/kigali/",
          "label": "キガリ",
          "country_ja": "ルワンダ共和国"
        },
        {
          "point_id": "/9/democratic-republic-of-the-congo/kinshasa/",
          "label": "キンシャサ",
          "country_ja": "コンゴ民主共和国"
        },
        {
          "point_id": "/9/south-africa/kimberley/",
          "label": "キンバリー",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/egypt/giza/",
          "label": "ギザ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/burundi/gitega/",
          "label": "ギテガ",
          "country_ja": "ブルンジ共和国"
        },
        {
          "point_id": "/9/south-africa/cape-town/",
          "label": "ケープタウン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/benin/cotonou/",
          "label": "コトヌー",
          "country_ja": "ベナン"
        },
        {
          "point_id": "/9/guinea/conakry/",
          "label": "コナクリ",
          "country_ja": "ギニア"
        },
        {
          "point_id": "/9/egypt/kom-ombo/",
          "label": "コムオンボ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/algeria/constantine/",
          "label": "コンスタンティーヌ",
          "country_ja": "アルジェリア"
        },
        {
          "point_id": "/9/sao-tome-and-principe/sao-tome/",
          "label": "サントメ",
          "country_ja": "サントメ・プリンシペ民主共和国"
        },
        {
          "point_id": "/9/tunisia/sidi-bou-said/",
          "label": "シディブサイド",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/morocco/chefchaouen/",
          "label": "シャウエン",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/tunisia/djerba/",
          "label": "ジェルバ島",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/saint-helena-islands/jamestown/",
          "label": "ジェームズタウン（セントヘレナ島）",
          "country_ja": "セントヘレナ諸島"
        },
        {
          "point_id": "/9/djibouti/djibouti/",
          "label": "ジブチ",
          "country_ja": "ジブチ共和国"
        },
        {
          "point_id": "/9/south-sudan/juba/",
          "label": "ジューバー",
          "country_ja": "南スーダン"
        },
        {
          "point_id": "/9/tunisia/sfax/",
          "label": "スファックス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/south-africa/springbok/",
          "label": "スプリングボック",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/tunisia/sousse/",
          "label": "スース",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tanzania/tabora/",
          "label": "タボラ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/algeria/tamanrasset/",
          "label": "タマンラセト",
          "country_ja": "アルジェリア"
        },
        {
          "point_id": "/9/morocco/tangier/",
          "label": "タンジェ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/senegal/dakar/",
          "label": "ダカール",
          "country_ja": "セネガル"
        },
        {
          "point_id": "/9/tanzania/dar-es-salaam/",
          "label": "ダルエスサラーム",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/south-africa/durban/",
          "label": "ダーバン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/tunisia/tunis/",
          "label": "チュニス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/botswana/tshane/",
          "label": "ツアーネ",
          "country_ja": "ボツワナ"
        },
        {
          "point_id": "/9/mauritania/tidjikja/",
          "label": "ティジクジャ",
          "country_ja": "モーリタニア"
        },
        {
          "point_id": "/9/tunisia/tozeur/",
          "label": "トズル",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/libya/tripoli/",
          "label": "トリポリ",
          "country_ja": "リビア"
        },
        {
          "point_id": "/9/tanzania/dodoma/",
          "label": "ドドマ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/kenya/nairobi/",
          "label": "ナイロビ",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/kenya/nakuru/",
          "label": "ナクル",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/south-africa/namaqualand/",
          "label": "ナマクワランド",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/niger/niamey/",
          "label": "ニアメー",
          "country_ja": "ニジェール"
        },
        {
          "point_id": "/9/sudan/nyala/",
          "label": "ニャラ",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/mauritania/nouakchott/",
          "label": "ヌアクショット",
          "country_ja": "モーリタニア"
        },
        {
          "point_id": "/9/botswana/gaborone/",
          "label": "ハボローネ",
          "country_ja": "ボツワナ"
        },
        {
          "point_id": "/9/zimbabwe/harare/",
          "label": "ハラレ",
          "country_ja": "ジンバブエ"
        },
        {
          "point_id": "/9/sudan/khartoum/",
          "label": "ハルツーム",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/mali/bamako/",
          "label": "バマコ",
          "country_ja": "マリ"
        },
        {
          "point_id": "/9/central-african-republic/bangui/",
          "label": "バンギ",
          "country_ja": "中央アフリカ共和国"
        },
        {
          "point_id": "/9/gambia/banjul/",
          "label": "バンジュール",
          "country_ja": "ガンビア"
        },
        {
          "point_id": "/9/seychelles/victoria/",
          "label": "ビクトリア",
          "country_ja": "セーシェル"
        },
        {
          "point_id": "/9/guinea-bissau/bissau/",
          "label": "ビサウ",
          "country_ja": "ギニアビサウ共和国"
        },
        {
          "point_id": "/9/mauritania/bir-moghrein/",
          "label": "ビルモグレイン",
          "country_ja": "モーリタニア"
        },
        {
          "point_id": "/9/madagascar/fianarantsoa/",
          "label": "フィアナランツォア",
          "country_ja": "マダガスカル"
        },
        {
          "point_id": "/9/morocco/fez-city/",
          "label": "フェズ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/south-africa/franschhoek/",
          "label": "フランシュフック",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/sierra-leone/freetown/",
          "label": "フリータウン",
          "country_ja": "シエラレオネ共和国"
        },
        {
          "point_id": "/9/ivory-coast/bouake/",
          "label": "ブアケ",
          "country_ja": "コートジボワール"
        },
        {
          "point_id": "/9/republic-of-the-congo/brazzaville/",
          "label": "ブラザビル",
          "country_ja": "コンゴ共和国"
        },
        {
          "point_id": "/9/south-africa/bloemfontein/",
          "label": "ブルームフォンテーン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/cape-verde/praia/",
          "label": "プライア",
          "country_ja": "カーボベルデ"
        },
        {
          "point_id": "/9/south-africa/pretoria/",
          "label": "プレトリア",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/libya/benghazi/",
          "label": "ベンガジ",
          "country_ja": "リビア"
        },
        {
          "point_id": "/9/burkina-faso/bobo-dioulasso/",
          "label": "ボボ・ディウラッソ",
          "country_ja": "ブルキナファソ"
        },
        {
          "point_id": "/9/benin/porto-novo/",
          "label": "ポルト・ノボ",
          "country_ja": "ベナン"
        },
        {
          "point_id": "/9/republic-of-the-congo/pointe-noire/",
          "label": "ポワントノワール",
          "country_ja": "コンゴ共和国"
        },
        {
          "point_id": "/9/south-africa/port-elizabeth/",
          "label": "ポートエリザベス",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/sudan/port-sudan/",
          "label": "ポートスーダン",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/mauritius/port-louis/",
          "label": "ポートルイス",
          "country_ja": "モーリシャス共和国"
        },
        {
          "point_id": "/9/botswana/maun/",
          "label": "マウン",
          "country_ja": "ボツワナ"
        },
        {
          "point_id": "/9/lesotho/maseru/",
          "label": "マセル",
          "country_ja": "レソト王国"
        },
        {
          "point_id": "/9/mozambique/maputo/",
          "label": "マプート",
          "country_ja": "モザンビーク"
        },
        {
          "point_id": "/9/morocco/marrakesh/",
          "label": "マラケシュ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/niger/maradi/",
          "label": "マラディ",
          "country_ja": "ニジェール"
        },
        {
          "point_id": "/9/equatorial-guinea/malabo/",
          "label": "マラボ",
          "country_ja": "赤道ギニア共和国"
        },
        {
          "point_id": "/9/cape-verde/mindelo/",
          "label": "ミンドロ",
          "country_ja": "カーボベルデ"
        },
        {
          "point_id": "/9/tanzania/mwika/",
          "label": "ムウィカ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/eswatini/mbabane/",
          "label": "ムババネ",
          "country_ja": "エスワティニ王国"
        },
        {
          "point_id": "/9/tanzania/mwanza/",
          "label": "ムワンザ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/morocco/meknes/",
          "label": "メクネス",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/merzouga/",
          "label": "メルズーカ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/kenya/meru/",
          "label": "メルー",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/somalia/mogadishu/",
          "label": "モガディシュ",
          "country_ja": "ソマリア連邦共和国"
        },
        {
          "point_id": "/9/mali/mopti/",
          "label": "モプティ",
          "country_ja": "マリ"
        },
        {
          "point_id": "/9/comoros/moroni/",
          "label": "モロ二",
          "country_ja": "コモロ連合"
        },
        {
          "point_id": "/9/kenya/mombasa/",
          "label": "モンバサ",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/liberia/monrovia/",
          "label": "モンロビア",
          "country_ja": "リベリア共和国"
        },
        {
          "point_id": "/9/cameroon/yaounde/",
          "label": "ヤウンデ",
          "country_ja": "カメルーン"
        },
        {
          "point_id": "/9/ivory-coast/yamoussoukro/",
          "label": "ヤムスクロ",
          "country_ja": "コートジボワール"
        },
        {
          "point_id": "/9/south-africa/johannesburg/",
          "label": "ヨハネスブルグ",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/morocco/rabat/",
          "label": "ラバト",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/zambia/livingstone/",
          "label": "リビングストン",
          "country_ja": "ザンビア共和国"
        },
        {
          "point_id": "/9/malawi/lilongwe/",
          "label": "リロングウェ",
          "country_ja": "マラウイ共和国"
        },
        {
          "point_id": "/9/gabon/libreville/",
          "label": "リーブルビル",
          "country_ja": "ガボン"
        },
        {
          "point_id": "/9/angola/luanda/",
          "label": "ルアンダ",
          "country_ja": "アンゴラ"
        },
        {
          "point_id": "/9/egypt/luxor/",
          "label": "ルクソール",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/zambia/lusaka/",
          "label": "ルサカ",
          "country_ja": "ザンビア共和国"
        },
        {
          "point_id": "/9/eswatini/lobamba/",
          "label": "ロバンバ",
          "country_ja": "エスワティニ王国"
        },
        {
          "point_id": "/9/togo/lome/",
          "label": "ロメ",
          "country_ja": "トーゴ"
        },
        {
          "point_id": "/9/burkina-faso/ouagadougou/",
          "label": "ワガドゥグー",
          "country_ja": "ブルキナファソ"
        },
        {
          "point_id": "/9/sudan/wadi-halfa/",
          "label": "ワジ・ハルファ",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/morocco/ouarzazate/",
          "label": "ワルザーザート",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/cameroon/ngaoundere/",
          "label": "ンガウンデレ",
          "country_ja": "カメルーン"
        },
        {
          "point_id": "/9/chad/ndjamena/",
          "label": "ンジャメナ",
          "country_ja": "チャド"
        },
        {
          "point_id": "/9/zimbabwe/victoria-falls/",
          "label": "ヴィクトリアフォールズ",
          "country_ja": "ジンバブエ"
        }
      ],
      "algeria": [
        {
          "point_id": "/9/algeria/algiers/",
          "label": "アルジェ",
          "country_ja": "アルジェリア"
        },
        {
          "point_id": "/9/algeria/constantine/",
          "label": "コンスタンティーヌ",
          "country_ja": "アルジェリア"
        },
        {
          "point_id": "/9/algeria/tamanrasset/",
          "label": "タマンラセト",
          "country_ja": "アルジェリア"
        }
      ],
      "uganda": [
        {
          "point_id": "/9/uganda/arua/",
          "label": "アルア",
          "country_ja": "ウガンダ"
        },
        {
          "point_id": "/9/uganda/entebbe/",
          "label": "エンテベ",
          "country_ja": "ウガンダ"
        },
        {
          "point_id": "/9/uganda/kampala/",
          "label": "カンパラ",
          "country_ja": "ウガンダ"
        }
      ],
      "egypt": [
        {
          "point_id": "/9/egypt/aswan/",
          "label": "アスワン",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/abu-simbel/",
          "label": "アブシンベル",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/alexandria/",
          "label": "アレクサンドリア",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/edfu/",
          "label": "エドフ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/cairo/",
          "label": "カイロ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/giza/",
          "label": "ギザ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/kom-ombo/",
          "label": "コムオンボ",
          "country_ja": "エジプト"
        },
        {
          "point_id": "/9/egypt/luxor/",
          "label": "ルクソール",
          "country_ja": "エジプト"
        }
      ],
      "ethiopia": [
        {
          "point_id": "/9/ethiopia/addis-ababa/",
          "label": "アディスアベバ",
          "country_ja": "エチオピア"
        }
      ],
      "cameroon": [
        {
          "point_id": "/9/cameroon/yaounde/",
          "label": "ヤウンデ",
          "country_ja": "カメルーン"
        },
        {
          "point_id": "/9/cameroon/ngaoundere/",
          "label": "ンガウンデレ",
          "country_ja": "カメルーン"
        }
      ],
      "cape-verde": [
        {
          "point_id": "/9/cape-verde/praia/",
          "label": "プライア",
          "country_ja": "カーボベルデ"
        },
        {
          "point_id": "/9/cape-verde/mindelo/",
          "label": "ミンドロ",
          "country_ja": "カーボベルデ"
        }
      ],
      "gabon": [
        {
          "point_id": "/9/gabon/libreville/",
          "label": "リーブルビル",
          "country_ja": "ガボン"
        }
      ],
      "gambia": [
        {
          "point_id": "/9/gambia/banjul/",
          "label": "バンジュール",
          "country_ja": "ガンビア"
        }
      ],
      "guinea": [
        {
          "point_id": "/9/guinea/conakry/",
          "label": "コナクリ",
          "country_ja": "ギニア"
        }
      ],
      "kenya": [
        {
          "point_id": "/9/kenya/nairobi/",
          "label": "ナイロビ",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/kenya/nakuru/",
          "label": "ナクル",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/kenya/meru/",
          "label": "メルー",
          "country_ja": "ケニア"
        },
        {
          "point_id": "/9/kenya/mombasa/",
          "label": "モンバサ",
          "country_ja": "ケニア"
        }
      ],
      "republic-of-the-congo": [
        {
          "point_id": "/9/republic-of-the-congo/brazzaville/",
          "label": "ブラザビル",
          "country_ja": "コンゴ共和国"
        },
        {
          "point_id": "/9/republic-of-the-congo/pointe-noire/",
          "label": "ポワントノワール",
          "country_ja": "コンゴ共和国"
        }
      ],
      "democratic-republic-of-the-congo": [
        {
          "point_id": "/9/democratic-republic-of-the-congo/kinshasa/",
          "label": "キンシャサ",
          "country_ja": "コンゴ民主共和国"
        }
      ],
      "ivory-coast": [
        {
          "point_id": "/9/ivory-coast/bouake/",
          "label": "ブアケ",
          "country_ja": "コートジボワール"
        },
        {
          "point_id": "/9/ivory-coast/yamoussoukro/",
          "label": "ヤムスクロ",
          "country_ja": "コートジボワール"
        }
      ],
      "zimbabwe": [
        {
          "point_id": "/9/zimbabwe/harare/",
          "label": "ハラレ",
          "country_ja": "ジンバブエ"
        },
        {
          "point_id": "/9/zimbabwe/victoria-falls/",
          "label": "ヴィクトリアフォールズ",
          "country_ja": "ジンバブエ"
        }
      ],
      "sudan": [
        {
          "point_id": "/9/sudan/nyala/",
          "label": "ニャラ",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/sudan/khartoum/",
          "label": "ハルツーム",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/sudan/port-sudan/",
          "label": "ポートスーダン",
          "country_ja": "スーダン"
        },
        {
          "point_id": "/9/sudan/wadi-halfa/",
          "label": "ワジ・ハルファ",
          "country_ja": "スーダン"
        }
      ],
      "senegal": [
        {
          "point_id": "/9/senegal/kaolack/",
          "label": "カオラック",
          "country_ja": "セネガル"
        },
        {
          "point_id": "/9/senegal/dakar/",
          "label": "ダカール",
          "country_ja": "セネガル"
        }
      ],
      "saint-helena-islands": [
        {
          "point_id": "/9/saint-helena-islands/jamestown/",
          "label": "ジェームズタウン（セントヘレナ島）",
          "country_ja": "セントヘレナ諸島"
        }
      ],
      "seychelles": [
        {
          "point_id": "/9/seychelles/victoria/",
          "label": "ビクトリア",
          "country_ja": "セーシェル"
        }
      ],
      "tanzania": [
        {
          "point_id": "/9/tanzania/tabora/",
          "label": "タボラ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/tanzania/dar-es-salaam/",
          "label": "ダルエスサラーム",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/tanzania/dodoma/",
          "label": "ドドマ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/tanzania/mwika/",
          "label": "ムウィカ",
          "country_ja": "タンザニア"
        },
        {
          "point_id": "/9/tanzania/mwanza/",
          "label": "ムワンザ",
          "country_ja": "タンザニア"
        }
      ],
      "chad": [
        {
          "point_id": "/9/chad/ndjamena/",
          "label": "ンジャメナ",
          "country_ja": "チャド"
        }
      ],
      "central-african-republic": [
        {
          "point_id": "/9/central-african-republic/bangui/",
          "label": "バンギ",
          "country_ja": "中央アフリカ共和国"
        }
      ],
      "tunisia": [
        {
          "point_id": "/9/tunisia/el-djem/",
          "label": "エルジャム",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/gabes/",
          "label": "ガベス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/sidi-bou-said/",
          "label": "シディブサイド",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/djerba/",
          "label": "ジェルバ島",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/sfax/",
          "label": "スファックス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/sousse/",
          "label": "スース",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/tunis/",
          "label": "チュニス",
          "country_ja": "チュニジア"
        },
        {
          "point_id": "/9/tunisia/tozeur/",
          "label": "トズル",
          "country_ja": "チュニジア"
        }
      ],
      "togo": [
        {
          "point_id": "/9/togo/lome/",
          "label": "ロメ",
          "country_ja": "トーゴ"
        }
      ],
      "namibia": [
        {
          "point_id": "/9/namibia/windhoek/",
          "label": "ウィントフーク",
          "country_ja": "ナミビア"
        },
        {
          "point_id": "/9/namibia/walvis-bay/",
          "label": "ウォルビス・ベイ",
          "country_ja": "ナミビア"
        }
      ],
      "niger": [
        {
          "point_id": "/9/niger/niamey/",
          "label": "ニアメー",
          "country_ja": "ニジェール"
        },
        {
          "point_id": "/9/niger/maradi/",
          "label": "マラディ",
          "country_ja": "ニジェール"
        }
      ],
      "burkina-faso": [
        {
          "point_id": "/9/burkina-faso/bobo-dioulasso/",
          "label": "ボボ・ディウラッソ",
          "country_ja": "ブルキナファソ"
        },
        {
          "point_id": "/9/burkina-faso/ouagadougou/",
          "label": "ワガドゥグー",
          "country_ja": "ブルキナファソ"
        }
      ],
      "benin": [
        {
          "point_id": "/9/benin/cotonou/",
          "label": "コトヌー",
          "country_ja": "ベナン"
        },
        {
          "point_id": "/9/benin/porto-novo/",
          "label": "ポルト・ノボ",
          "country_ja": "ベナン"
        }
      ],
      "botswana": [
        {
          "point_id": "/9/botswana/tshane/",
          "label": "ツアーネ",
          "country_ja": "ボツワナ"
        },
        {
          "point_id": "/9/botswana/gaborone/",
          "label": "ハボローネ",
          "country_ja": "ボツワナ"
        },
        {
          "point_id": "/9/botswana/maun/",
          "label": "マウン",
          "country_ja": "ボツワナ"
        }
      ],
      "madagascar": [
        {
          "point_id": "/9/madagascar/antananarivo/",
          "label": "アンタナナリボ",
          "country_ja": "マダガスカル"
        },
        {
          "point_id": "/9/madagascar/fianarantsoa/",
          "label": "フィアナランツォア",
          "country_ja": "マダガスカル"
        }
      ],
      "mali": [
        {
          "point_id": "/9/mali/bamako/",
          "label": "バマコ",
          "country_ja": "マリ"
        },
        {
          "point_id": "/9/mali/mopti/",
          "label": "モプティ",
          "country_ja": "マリ"
        }
      ],
      "south-africa": [
        {
          "point_id": "/9/south-africa/kimberley/",
          "label": "キンバリー",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/cape-town/",
          "label": "ケープタウン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/springbok/",
          "label": "スプリングボック",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/durban/",
          "label": "ダーバン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/namaqualand/",
          "label": "ナマクワランド",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/franschhoek/",
          "label": "フランシュフック",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/bloemfontein/",
          "label": "ブルームフォンテーン",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/pretoria/",
          "label": "プレトリア",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/port-elizabeth/",
          "label": "ポートエリザベス",
          "country_ja": "南アフリカ共和国"
        },
        {
          "point_id": "/9/south-africa/johannesburg/",
          "label": "ヨハネスブルグ",
          "country_ja": "南アフリカ共和国"
        }
      ],
      "south-sudan": [
        {
          "point_id": "/9/south-sudan/juba/",
          "label": "ジューバー",
          "country_ja": "南スーダン"
        }
      ],
      "mozambique": [
        {
          "point_id": "/9/mozambique/maputo/",
          "label": "マプート",
          "country_ja": "モザンビーク"
        }
      ],
      "morocco": [
        {
          "point_id": "/9/morocco/erfoud/",
          "label": "エルフード",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/casablanca/",
          "label": "カサブランカ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/chefchaouen/",
          "label": "シャウエン",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/tangier/",
          "label": "タンジェ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/fez-city/",
          "label": "フェズ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/marrakesh/",
          "label": "マラケシュ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/meknes/",
          "label": "メクネス",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/merzouga/",
          "label": "メルズーカ",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/rabat/",
          "label": "ラバト",
          "country_ja": "モロッコ"
        },
        {
          "point_id": "/9/morocco/ouarzazate/",
          "label": "ワルザーザート",
          "country_ja": "モロッコ"
        }
      ],
      "mauritania": [
        {
          "point_id": "/9/mauritania/tidjikja/",
          "label": "ティジクジャ",
          "country_ja": "モーリタニア"
        },
        {
          "point_id": "/9/mauritania/nouakchott/",
          "label": "ヌアクショット",
          "country_ja": "モーリタニア"
        },
        {
          "point_id": "/9/mauritania/bir-moghrein/",
          "label": "ビルモグレイン",
          "country_ja": "モーリタニア"
        }
      ],
      "libya": [
        {
          "point_id": "/9/libya/aubery/",
          "label": "ウバリ",
          "country_ja": "リビア"
        },
        {
          "point_id": "/9/libya/tripoli/",
          "label": "トリポリ",
          "country_ja": "リビア"
        },
        {
          "point_id": "/9/libya/benghazi/",
          "label": "ベンガジ",
          "country_ja": "リビア"
        }
      ],
      "angola": [
        {
          "point_id": "/9/angola/luanda/",
          "label": "ルアンダ",
          "country_ja": "アンゴラ"
        }
      ],
      "eswatini": [
        {
          "point_id": "/9/eswatini/mbabane/",
          "label": "ムババネ",
          "country_ja": "エスワティニ王国"
        },
        {
          "point_id": "/9/eswatini/lobamba/",
          "label": "ロバンバ",
          "country_ja": "エスワティニ王国"
        }
      ],
      "eritrea": [
        {
          "point_id": "/9/eritrea/asmara/",
          "label": "アスマラ",
          "country_ja": "エリトリア国"
        }
      ],
      "guinea-bissau": [
        {
          "point_id": "/9/guinea-bissau/bissau/",
          "label": "ビサウ",
          "country_ja": "ギニアビサウ共和国"
        }
      ],
      "ghana": [
        {
          "point_id": "/9/ghana/accra/",
          "label": "アクラ",
          "country_ja": "ガーナ共和国"
        }
      ],
      "sao-tome-and-principe": [
        {
          "point_id": "/9/sao-tome-and-principe/sao-tome/",
          "label": "サントメ",
          "country_ja": "サントメ・プリンシペ民主共和国"
        }
      ],
      "zambia": [
        {
          "point_id": "/9/zambia/livingstone/",
          "label": "リビングストン",
          "country_ja": "ザンビア共和国"
        },
        {
          "point_id": "/9/zambia/lusaka/",
          "label": "ルサカ",
          "country_ja": "ザンビア共和国"
        }
      ],
      "sierra-leone": [
        {
          "point_id": "/9/sierra-leone/freetown/",
          "label": "フリータウン",
          "country_ja": "シエラレオネ共和国"
        }
      ],
      "djibouti": [
        {
          "point_id": "/9/djibouti/djibouti/",
          "label": "ジブチ",
          "country_ja": "ジブチ共和国"
        }
      ],
      "comoros": [
        {
          "point_id": "/9/comoros/moroni/",
          "label": "モロ二",
          "country_ja": "コモロ連合"
        }
      ],
      "equatorial-guinea": [
        {
          "point_id": "/9/equatorial-guinea/malabo/",
          "label": "マラボ",
          "country_ja": "赤道ギニア共和国"
        }
      ],
      "somalia": [
        {
          "point_id": "/9/somalia/mogadishu/",
          "label": "モガディシュ",
          "country_ja": "ソマリア連邦共和国"
        }
      ],
      "nigeria": [
        {
          "point_id": "/9/nigeria/abuja/",
          "label": "アブジャ",
          "country_ja": "ナイジェリア連邦共和国"
        }
      ],
      "burundi": [
        {
          "point_id": "/9/burundi/gitega/",
          "label": "ギテガ",
          "country_ja": "ブルンジ共和国"
        }
      ],
      "malawi": [
        {
          "point_id": "/9/malawi/lilongwe/",
          "label": "リロングウェ",
          "country_ja": "マラウイ共和国"
        }
      ],
      "mauritius": [
        {
          "point_id": "/9/mauritius/port-louis/",
          "label": "ポートルイス",
          "country_ja": "モーリシャス共和国"
        }
      ],
      "liberia": [
        {
          "point_id": "/9/liberia/monrovia/",
          "label": "モンロビア",
          "country_ja": "リベリア共和国"
        }
      ],
      "rwanda": [
        {
          "point_id": "/9/rwanda/kigali/",
          "label": "キガリ",
          "country_ja": "ルワンダ共和国"
        }
      ],
      "lesotho": [
        {
          "point_id": "/9/lesotho/maseru/",
          "label": "マセル",
          "country_ja": "レソト王国"
        }
      ]
    }
  }
}
